var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReact(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "510 -235 1100 550",
    style: {
      enableBackground: "new 510 -235 1100 550"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\t.st0{fill:#E0E0E0;}\t.st1{fill:none;}\t.st2{fill:#EBEBEB;}\t.st3{fill:#263238;}\t.st4{fill:#202F69;}\t.st5{fill:#FFFFFF;}\t.st6{fill:#D2D2D2;}\t.st7{fill:#070707;}\t.st8{fill:#455A64;}\t.st9{fill:#E8505B;}\t.st10{fill:#FAFAFA;}\t.st11{fill:#FFBE9D;}\t.st12{fill:#EB996E;}\t.st13{opacity:0.3;}\t.st14{fill:#D1D1D1;}\t.st15{fill:#ECECEC;}\t.st16{opacity:0.4;}\t.st17{fill:#B78876;}\t.st18{fill:#ED1C24;}\t.st19{fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\t.st20{fill:#AA6550;}\t.st21{fill:#FFC727;}\t.st22{opacity:0.2;}\t.st23{fill:#01A9DA;}\t.st24{fill:#02AAD9;}\t.st25{fill:#02AADB;}\t.st26{fill:#03AAD8;}\t.st27{fill:#02AADA;}\t.st28{fill:#01AADA;}\t.st29{fill:#01A9DB;}\t.st30{fill:#04AADB;}\t.st31{fill:#04AADC;}\t.st32{fill:#02A9DB;}\t.st33{fill:#02ABDC;}\t.st34{fill:#04AAD8;}\t.st35{fill:#01A9D4;}\t.st36{fill:#06AAD9;}\t.st37{fill:#04AAD6;}\t.st38{fill:#0CAED6;}\t.st39{fill:#FDFEFE;}\t.st40{fill:#FAFCFD;}\t.st41{fill:#F9FCFD;}\t.st42{fill:#FCFDFD;}\t.st43{fill:#FCFDFE;}\t.st44{fill:#00AAD8;}\t.st45{fill:#01AAD9;}\t.st46{fill:#03A9D5;}\t.st47{fill:#04ABDC;}\t.st48{fill:#03ABDC;}\t.st49{fill:#FEFEFE;}\t.st50{fill:#FDFDFE;}\t.st51{fill:#00ABD2;}\t.st52{fill:#04ACD4;}\t.st53{fill:#07ABDE;}\t.st54{fill:#07AADD;}\t.st55{fill:#04ABD7;}\t.st56{fill:#0AABDE;}\t.st57{fill:#06A5E0;}\t.st58{fill:#01ABD5;}\t.st59{fill:#04ACD5;}\t.st60{fill:#09A4DF;}\t.st61{fill:#00A9D8;}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-49.583 -47.801)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(100.181 47.801)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(736.282)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(106.295 72.766)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M630.1-211.2c5.6,2.9,10.8,6.6,15.4,10.9l16.5-5.9l15.5,24.5l-12.3,12.4c1.9,6,3,12.3,3.2,18.6l15.8,7.5     l-6.3,28.3l-17.5,0c-2.9,5.6-6.6,10.8-10.9,15.4l5.9,16.5l-24.5,15.5l-12.4-12.4c-6,1.9-12.3,3-18.6,3.2l-7.5,15.8l-28.3-6.3     l0-17.5c-5.6-2.9-10.8-6.6-15.4-10.9l-16.5,5.9l-15.5-24.5l12.4-12.4c-1.9-6-3-12.3-3.2-18.6l-15.8-7.5l6.3-28.2l17.5,0     c2.9-5.6,6.6-10.8,10.9-15.4l-5.9-16.5l24.5-15.5l12.4,12.3c6-1.9,12.3-3,18.6-3.2l7.5-15.8l28.3,6.3L630.1-211.2L630.1-211.2z      M605.2-177.9c-16.7-3.8-33.4,6.8-37.1,23.5c-3.8,16.7,6.8,33.4,23.5,37.1c16.7,3.8,33.4-6.8,37.1-23.5c0,0,0,0,0,0     C632.4-157.6,621.9-174.2,605.2-177.9L605.2-177.9z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.429 41.74)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M538.5-234.2c1.9,0.3,3.7,0.8,5.4,1.7c4.8,2.3,8.6,6.2,10.8,10.9c1.6,3.3,2.3,6.9,2.2,10.6     c-0.1,4.2-1.4,8.3-3.6,11.8c-2.5,3.9-6.1,7-10.4,8.9c-9.4,4.2-20.5,1.7-27.2-6.1c-3.1-3.5-5-7.9-5.6-12.5     c-0.5-4.2,0.1-8.4,1.8-12.3c1.5-3.3,3.7-6.3,6.5-8.6c4.1-3.4,9.2-5.2,14.4-5.3C534.8-235,536.7-234.8,538.5-234.2     c0,0.2-2-0.4-5.6-0.3c-5.1,0.2-10,2.2-13.9,5.5c-5.8,4.9-8.7,12.5-7.7,20c0.6,4.4,2.4,8.5,5.3,11.8c6.4,7.3,16.8,9.7,25.7,5.8     c4-1.8,7.5-4.7,9.9-8.4c4.1-6.4,4.7-14.4,1.6-21.4c-2.1-4.7-5.7-8.5-10.2-10.9C540.5-233.7,538.5-234.1,538.5-234.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M599.4-217c0-0.3-0.1-0.5,0-0.8c0-0.6,0-1.4-0.1-2.4c0-2.2-0.1-5.5-0.1-9.7l0.2,0.2l-20.9-4.6l0.4-0.2    l-5.5,11.7l-0.1,0.2l-0.2,0c-4.6,0.2-9.2,1-13.6,2.4l-0.2,0.1l-0.2-0.2c-2.9-2.8-6-5.9-9.2-9.1l0.6,0.1l-18,11.5l0.2-0.6    l4.4,12.2l0.1,0.3l-0.2,0.2c-3.1,3.4-5.8,7.2-7.9,11.3l-0.2,0.3h-0.3l-12.9,0l0.6-0.5c-1.5,6.6-3,13.6-4.7,20.9l-0.3-0.7    l11.7,5.5l0.3,0.2l0,0.4c0.2,4.6,1,9.2,2.4,13.6l0.1,0.4l-0.3,0.3l-9.1,9.2l0.1-0.8l11.4,18.1l-0.8-0.3l12.2-4.3l0.4-0.1l0.3,0.3    c3.4,3.1,7.2,5.8,11.2,7.9h0l0,0c0.2,0.3-0.3-0.6,0.4,0.6v0.8v0.8v1.6l0,3.2c0,2.2,0,4.3,0,6.4l-0.5-0.6l20.9,4.7l-0.7,0.4    c1.9-3.9,3.7-7.8,5.5-11.7l0.2-0.4l0.4,0c4.6-0.2,9.2-1,13.6-2.4l0.4-0.1l0.3,0.3l9.2,9.1l-0.8-0.1l18.1-11.4l-0.2,0.7    c-1.5-4.1-2.9-8.2-4.3-12.2l-0.1-0.3l0.2-0.3c3.1-3.4,5.8-7.2,8-11.3l0.2-0.3h0.3l12.9,0l-0.5,0.4c1.7-7.3,3.2-14.3,4.7-20.8    l0.3,0.6l-11.7-5.6l-0.3-0.1l0-0.3c-0.2-4.6-1-9.2-2.3-13.6l-0.1-0.3l0.2-0.2l9.1-9.1l-0.1,0.5l-11.4-18.1l0.3,0.1l-12.2,4.3    l-0.1,0l-0.1-0.1c-2.6-2.4-5.3-4.5-8.3-6.4l-2.2-1.3C599.8-216.7,599.6-216.9,599.4-217c0.3,0.1,0.5,0.2,0.8,0.4    c0.5,0.3,1.3,0.7,2.3,1.2c3,1.8,5.9,3.9,8.5,6.3l-0.2,0c3.3-1.2,7.3-2.6,12.1-4.4l0.2-0.1l0.1,0.2c3.3,5.1,7.1,11,11.5,18    l0.2,0.3l-0.2,0.2l-9.1,9.2l0.1-0.4c1.4,4.5,2.3,9.1,2.5,13.8l-0.3-0.4l11.7,5.5l0.4,0.2l-0.1,0.4c-1.5,6.6-3,13.5-4.6,20.9    l-0.1,0.4h-0.4l-12.9,0.1l0.5-0.3c-2.2,4.2-4.9,8.1-8.1,11.5l0.1-0.6c1.4,4,2.9,8,4.3,12.2l0.2,0.5l-0.4,0.3l-18,11.5l-0.4,0.3    l-0.4-0.4l-9.2-9.1l0.6,0.2c-4.5,1.4-9.2,2.2-13.9,2.4l0.6-0.4l-5.5,11.7l-0.2,0.5l-0.5-0.1l-20.9-4.7l-0.5-0.1v-0.5    c0-2.1,0-4.3,0-6.4l0-3.2v-1.6v-1.6c0.7,1.2,0.2,0.3,0.4,0.6l0,0h0c-4.2-2.2-8.1-4.9-11.5-8.1l0.7,0.1l-12.2,4.3l-0.5,0.2    l-0.3-0.4L515.1-145l-0.3-0.4l0.4-0.4c3.1-3.2,6.3-6.3,9.1-9.2l-0.2,0.6c-1.4-4.5-2.2-9.2-2.4-13.9l0.4,0.5l-11.7-5.6l-0.4-0.2    l0.1-0.5c1.6-7.2,3.2-14.3,4.7-20.9l0.1-0.5h0.5l12.9,0l-0.5,0.3c2.2-4.2,4.9-8,8.1-11.5l-0.1,0.6c-1.5-4.3-3-8.4-4.3-12.2    l-0.1-0.4l0.3-0.2c6.3-4,12.4-7.8,18.1-11.4l0.3-0.2l0.3,0.3l9.1,9.1l-0.4-0.1c4.5-1.4,9.1-2.2,13.8-2.4l-0.3,0.2    c2-4.2,3.9-8.1,5.6-11.6l0.1-0.2l0.3,0.1l20.8,4.8l0.2,0v0.2c0,4.2-0.1,7.4-0.1,9.6c0,1.1,0,1.9,0,2.5    C599.4-217.6,599.4-217.3,599.4-217z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 308.292)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.515 0.282)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M574.8-220.8c2.6,1.9,4.9,4.2,6.8,6.7l8.7-1.6l5.8,13.5L589-197c0.5,3.2,0.5,6.4,0.1,9.6l7.3,5l-5.5,13.6     l-8.8-1.4c-1.9,2.6-4.2,4.9-6.7,6.8l1.6,8.7l-13.5,5.8l-5.2-7.2c-3.2,0.5-6.4,0.5-9.6,0.1l-5,7.3l-13.6-5.5l1.4-8.8     c-2.6-1.9-4.9-4.2-6.8-6.7L516-168l-5.8-13.5l7.2-5.2c-0.5-3.2-0.5-6.4-0.1-9.6l-7.3-5l5.5-13.6l8.8,1.4     c1.9-2.6,4.2-4.9,6.7-6.8l-1.6-8.7l13.5-5.8l5.2,7.2c3.2-0.5,6.4-0.5,9.6-0.1l5-7.3l13.6,5.5L574.8-220.8L574.8-220.8z      M559.7-206.2c-8.1-3.2-17.2,0.7-20.5,8.7s0.7,17.2,8.7,20.5c8.1,3.2,17.2-0.7,20.5-8.7C571.7-193.8,567.7-202.9,559.7-206.2     C559.7-206.2,559.7-206.2,559.7-206.2L559.7-206.2z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.166 27.766)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M532-233.7c1.3,0.4,2.4,1,3.5,1.7c3,2.1,5.1,5.1,6.1,8.6c0.7,2.4,0.8,4.9,0.3,7.4c-0.6,2.8-1.9,5.5-3.8,7.6     c-2.1,2.4-4.9,4.1-8,4.9c-6.8,1.8-14.1-1.1-17.8-7.1c-1.7-2.7-2.5-5.9-2.4-9.1c0.1-2.9,1-5.7,2.6-8.1c1.4-2.1,3.2-3.9,5.4-5.1     c3.1-1.8,6.8-2.5,10.4-2C529.6-234.6,530.8-234.2,532-233.7c0,0.1-1.3-0.5-3.8-0.8c-3.5-0.4-7,0.4-10,2.2     c-4.5,2.7-7.3,7.5-7.4,12.7c-0.1,3,0.7,6,2.3,8.6c3.5,5.7,10.3,8.4,16.8,6.7c2.9-0.7,5.6-2.3,7.6-4.6c3.5-3.9,4.8-9.3,3.4-14.3     c-0.9-3.4-2.9-6.4-5.7-8.5C533.3-233.1,532-233.6,532-233.7z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M575.4-220.5c0-0.2,0-0.4,0.1-0.6l0.2-1.7c0.2-1.5,0.6-3.7,1-6.6l0.1,0.2l-13.6-5.4l0.3-0.1l-5,7.3l-0.1,0.1    l-0.2,0c-3.2-0.4-6.3-0.3-9.5,0.1l-0.2,0l-0.1-0.1l-5.2-7.2l0.4,0.1l-13.5,5.8l0.2-0.4c0.5,2.7,1,5.7,1.6,8.7l0,0.2l-0.2,0.1    c-2.5,2-4.7,4.2-6.6,6.8l-0.1,0.2l-0.2,0l-8.8-1.4l0.4-0.2c-1.7,4.3-3.6,8.9-5.5,13.6l-0.2-0.5l7.3,5l0.2,0.1l0,0.3    c-0.4,3.1-0.3,6.3,0.1,9.5l0,0.3l-0.2,0.2l-7.2,5.2l0.1-0.5c1.8,4.3,3.8,8.9,5.8,13.5l-0.5-0.3l8.7-1.6l0.3,0l0.2,0.2    c1.9,2.5,4.2,4.7,6.7,6.6l0,0l0,0c0.1,0.2-0.2-0.4,0.2,0.4v0v0l0,0l0,0.1l0,0.1l0,0.3l-0.1,0.6l-0.2,1.1l-0.4,2.2    c-0.2,1.5-0.5,2.9-0.7,4.4l-0.3-0.5l13.6,5.5l-0.5,0.2l5-7.3l0.2-0.2l0.3,0c3.1,0.4,6.3,0.4,9.4-0.1l0.3,0l0.2,0.2    c1.8,2.4,3.5,4.8,5.2,7.2l-0.5-0.1l13.5-5.7l-0.2,0.5c-0.5-3-1.1-5.9-1.6-8.7l0-0.2l0.2-0.2c2.5-1.9,4.7-4.2,6.6-6.7l0.1-0.2    l0.2,0l8.8,1.4l-0.4,0.2l5.5-13.6l0.1,0.4l-7.3-5.1l-0.2-0.1l0-0.2c0.4-3.2,0.4-6.3-0.1-9.5l0-0.2l0.1-0.1l7.2-5.2l-0.1,0.3    l-5.7-13.5l0.2,0.1c-3.5,0.6-6.3,1.1-8.7,1.5l-0.1,0l-0.1-0.1c-1.5-1.9-3.1-3.7-4.9-5.2c-0.6-0.5-1-0.9-1.4-1.2    C575.6-220.2,575.5-220.3,575.4-220.5c0.2,0.1,0.3,0.2,0.5,0.3c0.3,0.2,0.8,0.6,1.4,1.1c1.9,1.5,3.5,3.3,5,5.2l-0.1-0.1l8.7-1.6    l0.2,0l0.1,0.1c1.6,3.8,3.6,8.3,5.8,13.5l0.1,0.2l-0.2,0.1l-7.2,5.2l0.1-0.3c0.5,3.2,0.5,6.4,0.1,9.6l-0.1-0.3l7.3,5l0.2,0.2    l-0.1,0.3l-5.4,13.6l-0.1,0.3l-0.3,0c-2.8-0.5-5.8-0.9-8.8-1.4l0.4-0.2c-1.9,2.6-4.2,4.9-6.8,6.9l0.2-0.4    c0.5,2.9,1.1,5.8,1.6,8.7l0.1,0.3l-0.3,0.1c-4.4,1.9-8.9,3.8-13.5,5.8l-0.3,0.1l-0.2-0.3c-1.7-2.4-3.4-4.8-5.2-7.2l0.4,0.2    c-3.2,0.5-6.5,0.5-9.7,0.1l0.4-0.2c-1.7,2.4-3.3,4.8-5,7.3l-0.2,0.3l-0.3-0.1l-13.6-5.5l-0.3-0.1l0.1-0.4    c0.2-1.4,0.5-2.9,0.7-4.4l0.4-2.2l0.2-1.1l0.1-0.6l0-0.3l0-0.1l0-0.1l0,0v0v0c0.4,0.9,0.1,0.2,0.2,0.4l0,0l0,0    c-2.6-1.9-4.9-4.2-6.9-6.8l0.4,0.2l-8.7,1.6l-0.4,0.1l-0.1-0.3c-2-4.6-3.9-9.2-5.8-13.5l-0.1-0.3l0.3-0.2l7.2-5.2l-0.2,0.4    c-0.5-3.2-0.5-6.5-0.1-9.7l0.2,0.4l-7.3-5l-0.3-0.2l0.1-0.3c1.9-4.7,3.8-9.3,5.5-13.6l0.1-0.3l0.3,0.1l8.8,1.4l-0.4,0.2    c1.9-2.6,4.2-4.9,6.8-6.9l-0.1,0.4c-0.6-3-1.1-6-1.6-8.7l-0.1-0.3l0.3-0.1l13.5-5.7l0.2-0.1l0.2,0.2l5.2,7.2l-0.3-0.1    c3.2-0.5,6.4-0.5,9.6-0.1l-0.2,0.1l5.1-7.3l0.1-0.2l0.2,0.1l13.6,5.5l0.1,0l0,0.1c-0.5,2.8-0.9,5-1.1,6.5    c-0.1,0.7-0.2,1.3-0.3,1.7C575.5-220.9,575.4-220.7,575.4-220.5z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(67.492 63.165)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M623.6-210.1c4.5,3.4,8.5,7.3,12,11.7l15.3-2.8l10.1,23.7l-12.6,9.1c0.8,5.6,0.9,11.2,0.2,16.8l12.8,8.8     l-9.6,23.9l-15.3-2.5c-3.4,4.5-7.3,8.5-11.7,12l2.8,15.3L603.8-84l-9.1-12.6c-5.6,0.8-11.2,0.9-16.8,0.2l-8.8,12.8l-23.9-9.6     l2.5-15.3c-4.5-3.4-8.5-7.3-12-11.7l-15.3,2.8l-10.1-23.7l12.6-9.1c-0.8-5.6-0.9-11.2-0.2-16.8l-12.8-8.8l9.6-23.9l15.3,2.5     c3.4-4.5,7.3-8.5,11.7-12l-2.8-15.3l23.7-10.1l9.1,12.6c5.6-0.8,11.2-0.9,16.8-0.2l8.8-12.8l23.9,9.6L623.6-210.1z M597-184.5     c-14.1-5.7-30.2,1.2-35.9,15.3c-5.7,14.1,1.2,30.2,15.3,35.9c14.1,5.7,30.2-1.2,35.9-15.3c0,0,0,0,0,0     C618-162.7,611.2-178.8,597-184.5L597-184.5z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(93.886 84.326)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.479)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M676.9-27.4H510V-235l127.7,0.4l39.2,42.6V-27.4z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.396 59.769)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 10.282)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M534.5-186.6c-0.2,0.2-3-2.3-7.3-6.5s-10.2-10.1-16.5-16.8l-0.7-0.7l0.7-0.7l0.1-0.1      c6.3-6.7,12.2-12.7,16.5-16.9s7.1-6.8,7.3-6.6c0.2,0.2-2.2,3.1-6.2,7.6c-4,4.5-9.7,10.7-16,17.4l-0.1,0.1v-1.5      c6.4,6.6,12,12.7,16.1,17.2S534.7-186.8,534.5-186.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(91.484 10.282)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M510-235c0.2-0.2,3,2.3,7.3,6.5c4.3,4.2,10.2,10.1,16.5,16.8l0.7,0.7l-0.7,0.7l-0.1,0.1      c-6.3,6.7-12.2,12.7-16.5,16.9s-7.1,6.8-7.3,6.6c-0.2-0.2,2.2-3.1,6.2-7.6c4-4.5,9.7-10.7,16-17.4l0.1-0.1v1.5      c-6.4-6.6-12-12.7-16.1-17.2C512.2-231.9,509.8-234.8,510-235z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(37.687)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M510-168.7c-0.5-0.3,8.2-15.4,19.3-33.7s20.7-32.9,21.2-32.6c0.5,0.3-8.2,15.4-19.3,33.7      S510.5-168.4,510-168.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(127.501 0.389)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M510.1-235l-0.1,34.8c0,4.9,4,9,8.9,9c0.1,0,0.2,0,0.3,0l30.2-1.1L510.1-235z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 140.595)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 510,
    y: -235,
    className: "st4",
    width: 74,
    height: 45
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.029 11.276)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.264)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M510-214.9l1.9-2.3c1,1.7,2.9,2.7,4.8,2.8c2.6,0,4-1.6,4-4.7v-13h-8.4v-2.9H524v15.8      c0,5.2-2.5,7.7-7.3,7.7C514.1-211.4,511.6-212.7,510-214.9z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.683)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M510-214.2l1.2-2.6c2.2,1.8,4.9,2.7,7.7,2.7c4,0,5.7-1.6,5.7-3.6c0-5.7-14.1-2.1-14.1-10.7      c0-3.6,2.8-6.6,8.9-6.6c2.6,0,5.2,0.7,7.5,2.1l-1.1,2.7c-1.9-1.2-4.1-1.9-6.4-1.9c-4,0-5.6,1.7-5.6,3.7      c0,5.7,14.1,2.1,14.1,10.7c0,3.6-2.9,6.6-9,6.6C515.3-211.2,511.9-212.4,510-214.2z"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(657.277 197.994)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 510,
    y: -235,
    className: "st6",
    width: 376.4,
    height: 219.3
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.078 7.952)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M510.4-34.7c-0.2,0-0.4-44.8-0.4-100.2c0-55.3,0.2-100.2,0.4-100.2s0.4,44.8,0.4,100.2    C510.7-79.5,510.6-34.7,510.4-34.7z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.233 16.041)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M522.5-234.6c0,0.2-2.8,0.4-6.2,0.4c-3.4,0-6.2-0.2-6.2-0.4s2.8-0.4,6.2-0.4    C519.7-235,522.5-234.8,522.5-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.233 29.241)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M522.5-234.6c0,0.2-2.8,0.4-6.2,0.4c-3.4,0-6.2-0.2-6.2-0.4s2.8-0.4,6.2-0.4    C519.7-235,522.5-234.8,522.5-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.233 42.442)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M522.5-234.6c0,0.2-2.8,0.4-6.2,0.4c-3.4,0-6.2-0.2-6.2-0.4s2.8-0.4,6.2-0.4    C519.7-235,522.5-234.8,522.5-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.233 55.641)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M522.5-234.6c0,0.2-2.8,0.4-6.2,0.4c-3.4,0-6.2-0.2-6.2-0.4s2.8-0.4,6.2-0.4    C519.7-235,522.5-234.8,522.5-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.233 68.841)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M522.5-234.6c0,0.2-2.8,0.4-6.2,0.4c-3.4,0-6.2-0.2-6.2-0.4s2.8-0.4,6.2-0.4    C519.7-235,522.5-234.8,522.5-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.233 82.041)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M522.5-234.6c0,0.2-2.8,0.4-6.2,0.4c-3.4,0-6.2-0.2-6.2-0.4s2.8-0.4,6.2-0.4    C519.7-235,522.5-234.8,522.5-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.233 95.241)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M522.5-234.6c0,0.2-2.8,0.4-6.2,0.4c-3.4,0-6.2-0.2-6.2-0.4s2.8-0.4,6.2-0.4    C519.7-235,522.5-234.8,522.5-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.233 108.442)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M522.5-234.6c0,0.2-2.8,0.4-6.2,0.4c-3.4,0-6.2-0.2-6.2-0.4s2.8-0.4,6.2-0.4    C519.7-235,522.5-234.8,522.5-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.233 121.641)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M522.5-234.6c0,0.2-2.8,0.4-6.2,0.4c-3.4,0-6.2-0.2-6.2-0.4s2.8-0.4,6.2-0.4    C519.7-235,522.5-234.8,522.5-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.233 134.841)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M522.5-234.6c0,0.2-2.8,0.4-6.2,0.4c-3.4,0-6.2-0.2-6.2-0.4s2.8-0.4,6.2-0.4    C519.7-235,522.5-234.8,522.5-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.233 148.042)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M522.5-234.6c0,0.2-2.8,0.4-6.2,0.4c-3.4,0-6.2-0.2-6.2-0.4s2.8-0.4,6.2-0.4    C519.7-235,522.5-234.8,522.5-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.233 161.241)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M522.5-234.6c0,0.2-2.8,0.4-6.2,0.4c-3.4,0-6.2-0.2-6.2-0.4s2.8-0.4,6.2-0.4    C519.7-235,522.5-234.8,522.5-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.233 174.442)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M522.5-234.6c0,0.2-2.8,0.4-6.2,0.4c-3.4,0-6.2-0.2-6.2-0.4s2.8-0.4,6.2-0.4    C519.7-235,522.5-234.8,522.5-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.233 187.642)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M522.5-234.6c0,0.2-2.8,0.4-6.2,0.4c-3.4,0-6.2-0.2-6.2-0.4s2.8-0.4,6.2-0.4    C519.7-235,522.5-234.8,522.5-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.233 200.843)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M522.5-234.6c0,0.2-2.8,0.4-6.2,0.4c-3.4,0-6.2-0.2-6.2-0.4s2.8-0.4,6.2-0.4    C519.7-235,522.5-234.8,522.5-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.312 15.263)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M542.4-234.6c0,0.2-7.2,0.4-16.2,0.4c-8.9,0-16.2-0.2-16.2-0.4s7.2-0.4,16.2-0.4    C535.1-235,542.4-234.8,542.4-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.312 200.843)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M542.4-234.6c0,0.2-7.2,0.4-16.2,0.4c-8.9,0-16.2-0.2-16.2-0.4s7.2-0.4,16.2-0.4    C535.1-235,542.4-234.8,542.4-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(56.188 42.442)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M570.5-234.6c0,0.2-13.6,0.4-30.3,0.4s-30.3-0.2-30.3-0.4s13.5-0.4,30.3-0.4S570.5-234.8,570.5-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(126.177 42.442)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M570.5-234.6c0,0.2-13.6,0.4-30.3,0.4c-16.7,0-30.3-0.2-30.3-0.4s13.5-0.4,30.3-0.4S570.5-234.8,570.5-234.6    z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70.754 55.641)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M599.2-234.6c0,0.2-20,0.4-44.6,0.4s-44.6-0.2-44.6-0.4s20-0.4,44.6-0.4C579.2-235,599.2-234.8,599.2-234.6z    "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70.754 68.841)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M599.2-234.6c0,0.2-20,0.4-44.6,0.4s-44.6-0.2-44.6-0.4s20-0.4,44.6-0.4C579.2-235,599.2-234.8,599.2-234.6z    "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(132.156 108.442)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M599.2-234.6c0,0.2-20,0.4-44.6,0.4s-44.6-0.2-44.6-0.4s20-0.4,44.6-0.4C579.2-235,599.2-234.8,599.2-234.6z    "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(105.658 82.041)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M599.2-234.6c0,0.2-20,0.4-44.6,0.4s-44.6-0.2-44.6-0.4s20-0.4,44.6-0.4C579.2-235,599.2-234.8,599.2-234.6z    "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(214.666 82.041)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M599.2-234.6c0,0.2-20,0.4-44.6,0.4s-44.6-0.2-44.6-0.4s20-0.4,44.6-0.4S599.2-234.8,599.2-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(176.757 55.641)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M599.2-234.6c0,0.2-20,0.4-44.6,0.4s-44.6-0.2-44.6-0.4s20-0.4,44.6-0.4S599.2-234.8,599.2-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(238.374 108.442)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M599.2-234.6c0,0.2-20,0.4-44.6,0.4s-44.6-0.2-44.6-0.4s20-0.4,44.6-0.4S599.2-234.8,599.2-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(176.757 68.841)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M648.5-234.6c0,0.2-31,0.4-69.3,0.4s-69.3-0.2-69.3-0.4s31-0.4,69.3-0.4S648.5-234.8,648.5-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.312 29.241)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M542.4-234.6c0,0.2-7.2,0.4-16.2,0.4c-8.9,0-16.2-0.2-16.2-0.4s7.2-0.4,16.2-0.4    C535.1-235,542.4-234.8,542.4-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.312 187.642)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M542.4-234.6c0,0.2-7.2,0.4-16.2,0.4c-8.9,0-16.2-0.2-16.2-0.4s7.2-0.4,16.2-0.4    C535.1-235,542.4-234.8,542.4-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(55.339 82.041)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M542.3-234.6c0,0.2-7.2,0.4-16.2,0.4s-16.2-0.2-16.2-0.4s7.2-0.4,16.2-0.4    C535.1-235,542.3-234.8,542.3-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(314.617 82.041)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M542.4-234.6c0,0.2-7.2,0.4-16.2,0.4s-16.2-0.2-16.2-0.4s7.2-0.4,16.2-0.4S542.4-234.8,542.4-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(56.188 134.763)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M570.5-234.6c0,0.2-13.6,0.4-30.3,0.4s-30.3-0.2-30.3-0.4s13.5-0.4,30.3-0.4S570.5-234.8,570.5-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(126.177 134.763)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M570.5-234.6c0,0.2-13.6,0.4-30.3,0.4c-16.7,0-30.3-0.2-30.3-0.4s13.5-0.4,30.3-0.4S570.5-234.8,570.5-234.6    z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70.754 147.964)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M599.2-234.6c0,0.2-20,0.4-44.6,0.4s-44.6-0.2-44.6-0.4s20-0.4,44.6-0.4C579.2-235,599.2-234.8,599.2-234.6z    "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70.754 161.164)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M599.2-234.6c0,0.2-20,0.4-44.6,0.4s-44.6-0.2-44.6-0.4s20-0.4,44.6-0.4C579.2-235,599.2-234.8,599.2-234.6z    "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(105.658 174.365)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M599.2-234.6c0,0.2-20,0.4-44.6,0.4s-44.6-0.2-44.6-0.4s20-0.4,44.6-0.4C579.2-235,599.2-234.8,599.2-234.6z    "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(214.666 174.365)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M599.2-234.6c0,0.2-20,0.4-44.6,0.4s-44.6-0.2-44.6-0.4s20-0.4,44.6-0.4S599.2-234.8,599.2-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(176.757 147.964)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M599.2-234.6c0,0.2-20,0.4-44.6,0.4s-44.6-0.2-44.6-0.4s20-0.4,44.6-0.4S599.2-234.8,599.2-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(176.757 161.164)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M648.5-234.6c0,0.2-31,0.4-69.3,0.4s-69.3-0.2-69.3-0.4s31-0.4,69.3-0.4S648.5-234.8,648.5-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(55.339 174.365)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M542.3-234.6c0,0.2-7.2,0.4-16.2,0.4s-16.2-0.2-16.2-0.4s7.2-0.4,16.2-0.4    C535.1-235,542.3-234.8,542.3-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(314.617 174.365)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M542.4-234.6c0,0.2-7.2,0.4-16.2,0.4s-16.2-0.2-16.2-0.4s7.2-0.4,16.2-0.4S542.4-234.8,542.4-234.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315.744 307.652)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.062)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M517.8-235h417.4c3.7,0,6.7,3,6.7,6.7V36.1c0,8-6.5,14.6-14.6,14.6H524.6c-8,0-14.6-6.5-14.6-14.6v-263.3    C510-231.5,513.5-235,517.8-235C517.8-235,517.8-235,517.8-235z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 264.495)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M510-235h467.9l0,0v11.3c0,7.6-6.1,13.7-13.7,13.7l0,0H523.7c-7.6,0-13.7-6.1-13.7-13.7c0,0,0,0,0,0V-235    L510-235z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.655 11.348)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 510,
    y: -235,
    className: "st0",
    width: 407.5,
    height: 241.2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(191.44 264.495)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M510-235l5.8,9.2h81.7l5.4-9.2H510z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.131 264.41)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 510,
    y: -235,
    className: "st3",
    width: 431.9,
    height: 1.4
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(41.747 25.322)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 510,
    y: -235,
    className: "st3",
    width: 384.3,
    height: 227.2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.126 4.389)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M510.4-18.8c-0.2,0-0.4-48.4-0.4-108.1c0-59.7,0.2-108.1,0.4-108.1s0.4,48.4,0.4,108.1     C510.7-67.2,510.6-18.8,510.4-18.8z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.248 23.623)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M522.5-234.6c0,0.2-2.8,0.4-6.2,0.4s-6.2-0.2-6.2-0.4s2.8-0.4,6.2-0.4S522.5-234.8,522.5-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.729 11.356)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M522.5-234.6c0,0.2-2.8,0.4-6.2,0.4s-6.2-0.2-6.2-0.4s2.8-0.4,6.2-0.4S522.5-234.8,522.5-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.248 36.844)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M522.5-234.6c0,0.2-2.8,0.4-6.2,0.4s-6.2-0.2-6.2-0.4s2.8-0.4,6.2-0.4S522.5-234.8,522.5-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.248 50.065)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M522.5-234.6c0,0.2-2.8,0.4-6.2,0.4s-6.2-0.2-6.2-0.4s2.8-0.4,6.2-0.4S522.5-234.8,522.5-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.248 63.286)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M522.5-234.6c0,0.2-2.8,0.4-6.2,0.4s-6.2-0.2-6.2-0.4s2.8-0.4,6.2-0.4S522.5-234.8,522.5-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.248 76.508)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M522.5-234.6c0,0.2-2.8,0.4-6.2,0.4s-6.2-0.2-6.2-0.4s2.8-0.4,6.2-0.4S522.5-234.8,522.5-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.248 89.73)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M522.5-234.6c0,0.2-2.8,0.4-6.2,0.4s-6.2-0.2-6.2-0.4s2.8-0.4,6.2-0.4S522.5-234.8,522.5-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.248 102.95)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M522.5-234.6c0,0.2-2.8,0.4-6.2,0.4s-6.2-0.2-6.2-0.4s2.8-0.4,6.2-0.4S522.5-234.8,522.5-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.248 116.171)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M522.5-234.6c0,0.2-2.8,0.4-6.2,0.4s-6.2-0.2-6.2-0.4s2.8-0.4,6.2-0.4S522.5-234.8,522.5-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.248 129.393)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M522.5-234.6c0,0.2-2.8,0.4-6.2,0.4s-6.2-0.2-6.2-0.4s2.8-0.4,6.2-0.4S522.5-234.8,522.5-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.248 142.615)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M522.5-234.6c0,0.2-2.8,0.4-6.2,0.4s-6.2-0.2-6.2-0.4s2.8-0.4,6.2-0.4S522.5-234.8,522.5-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.248 155.835)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M522.5-234.6c0,0.2-2.8,0.4-6.2,0.4s-6.2-0.2-6.2-0.4s2.8-0.4,6.2-0.4S522.5-234.8,522.5-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.248 169.057)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M522.5-234.6c0,0.2-2.8,0.4-6.2,0.4s-6.2-0.2-6.2-0.4s2.8-0.4,6.2-0.4S522.5-234.8,522.5-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.248 182.278)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M522.5-234.6c0,0.2-2.8,0.4-6.2,0.4s-6.2-0.2-6.2-0.4s2.8-0.4,6.2-0.4S522.5-234.8,522.5-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.248 195.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M522.5-234.6c0,0.2-2.8,0.4-6.2,0.4s-6.2-0.2-6.2-0.4s2.8-0.4,6.2-0.4S522.5-234.8,522.5-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.248 208.72)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M522.5-234.6c0,0.2-2.8,0.4-6.2,0.4s-6.2-0.2-6.2-0.4s2.8-0.4,6.2-0.4S522.5-234.8,522.5-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.375 22.843)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M542.4-234.6c0,0.2-7.3,0.4-16.2,0.4s-16.2-0.2-16.2-0.4s7.3-0.4,16.2-0.4     C535.2-235,542.4-234.8,542.4-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.375 208.72)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M542.4-234.6c0,0.2-7.3,0.4-16.2,0.4s-16.2-0.2-16.2-0.4s7.3-0.4,16.2-0.4     C535.2-235,542.4-234.8,542.4-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(56.278 50.065)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M570.6-234.6c0,0.2-13.6,0.4-30.3,0.4c-16.7,0-30.3-0.2-30.3-0.4s13.6-0.4,30.3-0.4     C557.1-235,570.6-234.8,570.6-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(126.38 50.065)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M570.6-234.6c0,0.2-13.6,0.4-30.3,0.4s-30.3-0.2-30.3-0.4s13.6-0.4,30.3-0.4     C557.1-235,570.6-234.8,570.6-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70.868 63.286)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M599.3-234.6c0,0.2-20,0.4-44.7,0.4s-44.7-0.2-44.7-0.4s20-0.4,44.7-0.4S599.3-234.8,599.3-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70.868 76.508)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M599.3-234.6c0,0.2-20,0.4-44.7,0.4s-44.7-0.2-44.7-0.4s20-0.4,44.7-0.4S599.3-234.8,599.3-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(132.368 116.171)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M599.3-234.6c0,0.2-20,0.4-44.7,0.4s-44.7-0.2-44.7-0.4s20-0.4,44.7-0.4S599.3-234.8,599.3-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(105.829 89.73)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M599.3-234.6c0,0.2-20,0.4-44.7,0.4s-44.7-0.2-44.7-0.4s20-0.4,44.7-0.4S599.3-234.8,599.3-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(215.012 89.73)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M599.3-234.6c0,0.2-20,0.4-44.7,0.4c-24.7,0-44.7-0.2-44.7-0.4s20-0.4,44.7-0.4     C579.4-235,599.3-234.8,599.3-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(177.041 63.286)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M599.4-234.6c0,0.2-20,0.4-44.7,0.4s-44.7-0.2-44.7-0.4s20-0.4,44.7-0.4S599.4-234.8,599.4-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(238.758 116.171)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M599.3-234.6c0,0.2-20,0.4-44.7,0.4s-44.7-0.2-44.7-0.4s20-0.4,44.7-0.4     C579.4-235,599.3-234.8,599.3-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(177.041 76.508)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M648.7-234.6c0,0.2-31.1,0.4-69.4,0.4c-38.3,0-69.4-0.2-69.4-0.4s31.1-0.4,69.4-0.4     C617.7-235,648.7-234.8,648.7-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.375 36.844)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M542.4-234.6c0,0.2-7.3,0.4-16.2,0.4s-16.2-0.2-16.2-0.4s7.3-0.4,16.2-0.4     C535.2-235,542.4-234.8,542.4-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.375 195.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M542.4-234.6c0,0.2-7.3,0.4-16.2,0.4s-16.2-0.2-16.2-0.4s7.3-0.4,16.2-0.4     C535.2-235,542.4-234.8,542.4-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(55.428 89.73)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M542.4-234.6c0,0.2-7.3,0.4-16.2,0.4c-8.9,0-16.2-0.2-16.2-0.4s7.3-0.4,16.2-0.4     C535.1-235,542.4-234.8,542.4-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315.123 89.73)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M542.4-234.6c0,0.2-7.3,0.4-16.2,0.4s-16.2-0.2-16.2-0.4s7.3-0.4,16.2-0.4     C535.1-235,542.4-234.8,542.4-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(56.278 142.536)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M570.6-234.6c0,0.2-13.6,0.4-30.3,0.4c-16.7,0-30.3-0.2-30.3-0.4s13.6-0.4,30.3-0.4     C557.1-235,570.6-234.8,570.6-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(126.38 142.536)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M570.6-234.6c0,0.2-13.6,0.4-30.3,0.4s-30.3-0.2-30.3-0.4s13.6-0.4,30.3-0.4     C557.1-235,570.6-234.8,570.6-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70.868 155.758)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M599.3-234.6c0,0.2-20,0.4-44.7,0.4s-44.7-0.2-44.7-0.4s20-0.4,44.7-0.4S599.3-234.8,599.3-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70.868 168.979)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M599.3-234.6c0,0.2-20,0.4-44.7,0.4s-44.7-0.2-44.7-0.4s20-0.4,44.7-0.4S599.3-234.8,599.3-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(105.829 182.201)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M599.3-234.6c0,0.2-20,0.4-44.7,0.4s-44.7-0.2-44.7-0.4s20-0.4,44.7-0.4S599.3-234.8,599.3-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(215.012 182.201)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M599.3-234.6c0,0.2-20,0.4-44.7,0.4c-24.7,0-44.7-0.2-44.7-0.4s20-0.4,44.7-0.4     C579.4-235,599.3-234.8,599.3-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(177.041 155.758)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M599.4-234.6c0,0.2-20,0.4-44.7,0.4s-44.7-0.2-44.7-0.4s20-0.4,44.7-0.4S599.4-234.8,599.4-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(177.041 168.979)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M648.7-234.6c0,0.2-31.1,0.4-69.4,0.4c-38.3,0-69.4-0.2-69.4-0.4s31.1-0.4,69.4-0.4     C617.7-235,648.7-234.8,648.7-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(55.428 182.201)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M542.4-234.6c0,0.2-7.3,0.4-16.2,0.4c-8.9,0-16.2-0.2-16.2-0.4s7.3-0.4,16.2-0.4     C535.1-235,542.4-234.8,542.4-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315.123 182.201)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M542.4-234.6c0,0.2-7.3,0.4-16.2,0.4s-16.2-0.2-16.2-0.4s7.3-0.4,16.2-0.4     C535.1-235,542.4-234.8,542.4-234.6z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(49.583 596.794)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1610-234.6c0,0.2-246.3,0.4-550,0.4c-303.8,0-550-0.2-550-0.4s246.2-0.4,550-0.4   C1363.7-235,1610-234.8,1610-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(867.91 390.431)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(58.828 115.135)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M510.4-221.6l5.5,17.3c2.2,7.2,8.1,12.5,15.5,13.9l36.9,6.9l10-0.3l-10-12.4l-27.7-9.5    c-2.7-0.6-4.9-2.6-5.6-5.3l-11-24l-14,8.6L510.4-221.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.913)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M540.9-222.6c0.2-2.7-0.5-5.4-2.1-7.7c-1.4-2.2-3.5-4.3-6.1-4.7c-3.1-0.3-6,1.4-7.2,4.2    c-1.1,2.8-0.7,6.1,1.1,8.5c0.9,1.3,2,2.3,3.4,3.1c-3.9,2.5-6.8,6.2-8.4,10.6c-0.5,1.5-0.9,3-1.5,4.4c-0.6,1.5-1.7,2.7-3.1,3.4    c-1,0.5-2.2,0.5-3.3,0.9c-1.8,0.7-3.2,2.3-3.6,4.2c-0.4,1.9-0.1,3.9,1,5.6c0.6,0.7,1.1,1.6,1.2,2.6c0,0.7-0.2,1.3-0.4,1.9    c-0.7,2.8,1.1,5.7,3.9,6.3c1.7,0.4,3.5,0,4.7-1.2c0.6,1.7,1.7,3.1,3.2,4c1.6,0.8,3.9,0.1,4.2-1.6c1,2.1,3.5,3,5.5,2    c1.4-0.6,2.3-2,2.4-3.5l29.8-32.6C561.3-223.9,543.9-222.9,540.9-222.6z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.764 4.589)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.21 10.658)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.576 3.479)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M513.3-230c-1.9,0.2-3.4,1.8-3.3,3.8l0,0l2.1,50.1c0.1,5.9,10.8,12.9,17.2,12.8l0,0       c6.4-0.1,4.5-6.9,4.6-12.6c0.2-9.4,0.2-12.9,0.2-12.9c0,0,8.1-1.3,9.8-11.9c0.8-5.2,0.6-13.9,0.1-20.9       c-0.4-6.3-4.6-14.1-10.9-13.4L513.3-230z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.702 16.523)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.773 2.554)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M512.7-233.8c0,0.7-0.6,1.3-1.3,1.4c-0.7,0.1-1.3-0.5-1.4-1.2c0,0,0,0,0,0c0-0.7,0.6-1.3,1.3-1.4         C512-235.1,512.6-234.5,512.7-233.8C512.7-233.8,512.7-233.8,512.7-233.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M515.3-233.6c-0.2,0.2-1.2-0.6-2.6-0.6c-1.5,0-2.5,0.7-2.7,0.6c-0.1-0.1,0.1-0.4,0.6-0.7        c0.6-0.4,1.4-0.7,2.1-0.7c0.8,0,1.5,0.2,2.1,0.7C515.3-234,515.4-233.7,515.3-233.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.387 16.794)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.852 2.283)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M512.7-233.8c0,0.7-0.6,1.3-1.3,1.4c-0.7,0.1-1.3-0.5-1.4-1.2c0,0,0,0,0,0c0-0.7,0.6-1.3,1.3-1.4         C512-235.1,512.6-234.5,512.7-233.8C512.7-233.8,512.7-233.8,512.7-233.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M515.3-233.6c-0.2,0.2-1.2-0.6-2.7-0.6c-1.5,0-2.5,0.7-2.7,0.6c-0.1-0.1,0.1-0.4,0.6-0.7        c0.6-0.4,1.4-0.7,2.1-0.7c0.8,0,1.5,0.2,2.1,0.7C515.3-234,515.4-233.7,515.3-233.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.339 16.883)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M510.7-222.9c0.8-0.2,1.6-0.4,2.4-0.4c0.4,0,0.7-0.1,0.8-0.4c0-0.4-0.1-0.8-0.2-1.1        c-0.3-0.9-0.7-1.8-1.1-2.8c-1.5-4-2.6-7.3-2.5-7.4s1.5,3.2,3.1,7.2c0.4,1,0.7,1.9,1.1,2.9c0.2,0.4,0.3,1,0.2,1.5        c-0.1,0.3-0.3,0.5-0.6,0.5c-0.2,0.1-0.4,0.1-0.6,0.1C512.3-222.8,511.5-222.8,510.7-222.9z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.895 42.477)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M524.1-231.2c-5,0.1-9.9-1.2-14.1-3.8c0,0,3.4,7.2,14,6.3L524.1-231.2z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.061 31.536)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M514.3-234c-0.6-0.7-1.5-1.1-2.4-1c-0.6,0.1-1.2,0.4-1.7,0.9c-0.4,0.5-0.4,1.2-0.1,1.7        c0.5,0.5,1.2,0.7,1.9,0.5c0.7-0.2,1.3-0.6,1.9-1.1c0.2-0.1,0.3-0.3,0.4-0.4C514.5-233.6,514.5-233.8,514.3-234"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.499 30.022)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M510.2-235c0.2,0,0.2,1.6,1.6,2.7s3,0.9,3,1.2c0,0.1-0.4,0.3-1.1,0.3c-0.9,0-1.8-0.3-2.5-0.9        c-0.7-0.6-1.1-1.4-1.2-2.3C510-234.6,510.1-235,510.2-235z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.746 14.576)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M516.6-233.9c-0.1,0.4-1.6,0.2-3.3,0.4c-1.7,0.2-3.1,0.7-3.3,0.3c-0.1-0.2,0.1-0.5,0.7-0.9        c1.5-1,3.4-1.2,5-0.6C516.4-234.4,516.7-234.1,516.6-233.9z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.556 12.222)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M515-233.5c-0.3,0.3-1.3,0-2.5,0c-1.2-0.1-2.2,0.2-2.5-0.1c-0.1-0.2,0.1-0.5,0.5-0.8        c1.2-0.8,2.8-0.7,4,0.1C514.9-234,515.1-233.7,515-233.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.564 25.042)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M515.2-234.7c-0.9-0.5-1.9-0.4-2.8,0.1c-2.3,1.4-3.1,4.3-1.8,6.7c1,1.7,2.9,2.7,4.9,2.4"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.123)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M529.2-235c3.6,0.2,7.1,1.3,10.1,3.1c3.5,1.8,6.1,4.9,7.2,8.6c0.3,0.8,0.3,1.6-0.1,2.4       c-0.7,0.9-1.9,1.1-2.9,0.6c-0.9-0.5-1.8-1.3-2.4-2.2c-0.6,2.4-3.1,3.9-5.5,3.2c-1.6-0.4-2.9-1.7-3.3-3.3       c-0.2,2.1-2,3.7-4.1,3.6c-2.1-0.2-3.8-1.6-4.5-3.5c-0.3,1.8-0.9,3.6-1.9,5.2c-1,1.6-2.9,2.4-4.8,1.9c0.4,1.6,0.4,3.2-0.1,4.7       c-0.6,1.5-2.2,2.7-3.7,2.2c-1.5-0.5-2-2.2-2.4-3.7c-0.8-2.9-1.1-5.9-1.1-8.8c-0.2-6.3,4.2-11.9,10.5-13.1c3-0.7,6.1-1,9.2-0.8       "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.631 27.395)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M512.4-230.9c0-0.1-0.4,0.1-0.9-0.1c-0.6-0.4-1-1.1-0.9-1.8c0-0.7,0.4-1.4,1.1-1.7       c0.5-0.2,0.9-0.1,0.9-0.2c0-0.1-0.4-0.3-1.1-0.2c-0.4,0.1-0.8,0.3-1,0.6c-0.3,0.4-0.5,0.9-0.5,1.4c-0.1,0.9,0.4,1.9,1.3,2.2       C512-230.5,512.4-230.9,512.4-230.9z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 31.992)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M516-235c-0.2,0-0.3,0.1-0.4,0.1c-0.4,0.1-0.8,0.3-1.2,0.5c-1.4,0.7-2.6,1.9-3.4,3.2       c-0.6,1-0.9,2.1-0.9,3.2c0,1.3,0.3,2.6,0.9,3.7c0.7,1.3,1.6,2.3,2.8,3.1c1.3,0.9,2.8,1.4,4.3,1.4c3-0.1,5.8-1.8,7.1-4.5       c0.6-1.2,0.9-2.4,0.8-3.7c-0.1-1.1-0.5-2.2-1-3.2c-0.8-1.4-2-2.5-3.5-3.2c-0.4-0.2-0.8-0.3-1.2-0.4c-0.1,0-0.3-0.1-0.4,0       c0,0.1,0.6,0.1,1.6,0.6c1.4,0.7,2.5,1.8,3.2,3.2c0.5,0.9,0.8,1.9,0.9,3c0.1,1.2-0.2,2.4-0.7,3.5c-1.3,2.5-3.9,4.1-6.7,4.1       c-2.8-0.1-5.3-1.7-6.7-4.2c-1.1-2-1.2-4.4,0-6.5c0.8-1.3,1.9-2.5,3.2-3.3C515.4-234.7,516-234.9,516-235z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.511)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M522.4-225c-0.1,0-0.3-0.9-1-2.3c-1.7-3.6-5-6.3-9-7.1c-1.5-0.3-2.5-0.3-2.5-0.4c0.8-0.2,1.7-0.3,2.5-0.1      c4.2,0.6,7.8,3.4,9.3,7.4C522.3-226.8,522.4-225.9,522.4-225z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 11.854)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M510.7-196.8c0,0-0.2-0.1-0.4-0.3c-0.3-0.4-0.4-0.9-0.2-1.4c0.2-0.8,0.6-1.5,1.3-1.9      c0.8-0.5,1.7-1,2.6-1.4c1-0.5,1.7-1.5,1.8-2.6c-0.1-1.3-0.3-2.7-0.7-4c-0.2-0.8-0.3-1.5-0.2-2.3c0.1-0.9,0.4-1.7,1-2.3      c1.3-1.2,2.8-2,4.5-2.3c1.6-0.5,3.1-1.1,4-2.3c0.7-1.3,1-2.7,0.7-4.2c-0.2-1.4-0.3-2.8-0.3-4.2c0.2-3,1.7-5.8,4-7.8      c0.4-0.3,0.8-0.6,1.2-0.8c0.3-0.2,0.4-0.2,0.5-0.2c0,0.1-0.6,0.4-1.4,1.2c-1.2,1.2-2.2,2.6-2.8,4.2c-0.4,1.1-0.7,2.2-0.8,3.4      c0,1.4,0.1,2.7,0.3,4.1c0.3,1.6,0.1,3.2-0.7,4.6c-1,1.5-2.8,2.1-4.3,2.6c-1.5,0.3-3,1.1-4.1,2.1c-0.9,1.1-1.1,2.7-0.6,4      c0.4,1.3,0.6,2.7,0.7,4.2c-0.1,0.7-0.3,1.3-0.7,1.9c-0.4,0.5-0.9,0.8-1.4,1.1c-1,0.5-1.9,0.8-2.6,1.3c-0.6,0.4-1.1,1-1.3,1.6      C510.2-198,510.3-197.3,510.7-196.8z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.269 9.764)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M523-222c-0.1,0-0.2-1.1-0.8-2.8c-1.4-4.5-4.9-8-9.4-9.4c-1.7-0.6-2.8-0.6-2.8-0.8c1-0.1,2,0,3,0.3      c4.8,1.2,8.5,5,9.8,9.7C523-224,523.1-223,523-222z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.025 8.37)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M531.8-225.2c-0.5-1.1-1.1-2.2-1.8-3.3c-1.8-2.4-4.4-4.1-7.2-5c-2.9-0.8-5.9-1.1-8.9-0.7      c-2.3,0.2-3.7,0.6-3.8,0.5c1.2-0.5,2.4-0.8,3.7-1c3.1-0.5,6.2-0.3,9.2,0.5c3,0.9,5.6,2.8,7.4,5.4c0.5,0.8,0.9,1.6,1.2,2.5      C531.7-225.9,531.8-225.5,531.8-225.2z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.127 7.296)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M521.2-235c0.1,0-0.3,0.7-1.1,1.5c-2.2,2.2-5.3,3.3-8.3,3c-0.6,0-1.3-0.2-1.8-0.5c0-0.2,2.9,0.5,6.1-0.7      C519.3-232.8,521.1-235.1,521.2-235z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.11 164.877)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.554 0.008)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M523.8-193.1c-25.4-8.4-8-41.9-8-41.9l110.8,10.4c8.9-0.1,16.1,7.1,16.1,15.9c0,0,0,0.1,0,0.1l0,0     c0,8.9-7.2,16-16,16c0,0,0,0,0,0L523.8-193.1"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M523.4-193.1c-24.7-8.3-7.7-41.9-7.7-41.9l108,10.2c10.5,0.1,15.7,5.2,15.7,16l0,0c0,8.9-3.3,16.3-15.7,16.1    L523.4-193.1"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(38.473 5.655)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M510-235c0.1,0,0.2,0,0.3,0l0.9,0l3.5,0.1l12.7,0.6c10.8,0.6,25.6,1.4,41.9,2.3c2,0.1,4.1,0.3,6.1,0.3     s4,0.1,5.9,0.2s3.8,0.3,5.7,0.5c1.8,0.1,3.7,0.5,5.4,1.1c1.7,0.6,3.2,1.6,4.5,2.9c1.2,1.2,2.1,2.7,2.7,4.4     c0.5,1.5,0.9,3.1,1.1,4.7c0.2,1.5,0.3,3,0.3,4.5c0,2.6-0.4,5.1-1.4,7.5c-0.7,1.8-1.9,3.3-3.4,4.6c-0.9,0.8-1.9,1.4-3.1,1.7     c-0.8,0.2-0.8,0.2,0-0.1c1.1-0.4,2.1-1,3-1.8c1.4-1.2,2.5-2.8,3.2-4.5c0.9-2.3,1.4-4.9,1.3-7.4c0-1.5-0.1-2.9-0.3-4.4     c-0.2-1.6-0.6-3.1-1.1-4.6c-0.6-1.6-1.5-3-2.6-4.2c-1.2-1.2-2.7-2.1-4.3-2.7c-1.7-0.6-3.5-0.9-5.3-1.1c-1.8-0.2-3.7-0.3-5.7-0.4     s-3.9-0.2-5.9-0.2s-4-0.2-6.1-0.3c-16.4-1-31.2-1.8-41.9-2.5l-12.7-0.8l-3.5-0.3l-0.9-0.1C510.2-234.9,510.1-235,510-235z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 68.752)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M588-131l-8.9-4.4l-6.2-20.6l-0.6-26.3l12.5-5.3l-9.9-25c-1.8-3.7-5.5-13.5-14.9-16.7    c-0.1-1.8,0-3.6,0.3-4.1c0.7-1.2-23-2-24.3-1.5c-1.2,0.5,0.2,4.8,0.1,5.6c-8.4,2.3-16.6,5.8-19.7,17.4c-1.2,4.5-0.8,14-0.2,18.6    l6.6,34.8l-3.7,11.4c0,0-12.9,27-8,37.5s13.3,12.9,13.3,12.9l64.5-0.1L588-131z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.619 0.135)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.646 30.639)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 29.84)",
    className: "st13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M510-232.9c1.1,4.8,2.9,11.9,4.7,16.5c1.2,3.4,3,6.6,5.2,9.5c3.3,3.8,7.6,6.4,12.4,7.6       c4.8,1.2,9.8,1.4,14.7,0.7l-24.4-13.8l-6.5-22.6L510-232.9z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.143)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M511.5-187.5c-0.1-0.6-0.2-1.2-0.2-1.9c-0.1-1.3-0.1-3-0.2-5.1c-0.2-4.3-0.4-10.2-0.6-16.8       s-0.3-12.5-0.4-16.8c0-2.1,0-3.8-0.1-5.1c0-0.6,0-1.3,0.1-1.9c0.1,0.6,0.2,1.2,0.2,1.9c0.1,1.3,0.1,3,0.2,5.1       c0.2,4.3,0.4,10.2,0.6,16.8s0.3,12.5,0.4,16.8c0,2.1,0,3.8,0.1,5.1C511.6-188.7,511.6-188.1,511.5-187.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 12.368)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M542.4-193.8c-0.1,0.1-0.3,0.1-0.4,0.2l-1.4,0.5l-5.3,1.9l-19.5,6.7l-0.3,0.1l-0.1-0.3      c-1.3-7.1-2.9-15.4-4.5-24.3v0v0c-0.3-4.4-1.1-9-0.8-13.9c0.2-1.2,0.5-2.3,0.9-3.4c0.4-1.1,1-2.1,1.6-3.1      c1.3-1.9,3.1-3.4,5.1-4.4c4-2,8.7-1.5,12.2,1.3c1.4,1.4,2.5,3.1,3.2,5c0.7,1.7,1.4,3.4,1.9,5.2c1,3.4,1.8,6.6,2.6,9.6      c1.5,5.8,2.7,10.6,3.5,13.9c0.4,1.6,0.7,2.8,0.9,3.7c0.1,0.4,0.2,0.7,0.2,1C542.4-194,542.4-193.9,542.4-193.8      c0-0.1-0.1-0.2-0.1-0.4l-0.3-1c-0.3-0.9-0.6-2.2-1.1-3.8c-0.9-3.3-2.2-8-3.8-13.8c-0.8-2.9-1.6-6.1-2.6-9.5      c-0.5-1.7-1.2-3.5-1.9-5.1c-0.7-1.8-1.8-3.4-3.1-4.7c-3.2-2.6-7.7-3.1-11.4-1.2c-2,0.9-3.6,2.4-4.8,4.1      c-0.6,0.9-1.1,1.9-1.5,2.9c-0.4,1-0.7,2.1-0.9,3.2c-0.4,4.7,0.5,9.3,0.8,13.8l0,0c1.6,9,3.1,17.2,4.4,24.3l-0.4-0.2l19.4-6.4      l5.4-1.8l1.4-0.5C542.1-193.7,542.2-193.8,542.4-193.8z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.303 42.625)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M511.7-230c-0.2,0.1-0.7-1-1.1-2.4s-0.7-2.6-0.5-2.6s0.7,1,1.1,2.4S511.9-230,511.7-230z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.053 41.01)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M511.3-230.2c-0.2,0-0.6-1-0.9-2.3s-0.4-2.5-0.2-2.5s0.6,1,0.9,2.3S511.5-230.2,511.3-230.2z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.445 39.533)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M511.3-231c-0.2,0.1-0.6-0.8-0.9-1.9s-0.4-2.1-0.3-2.1s0.6,0.8,0.9,1.9S511.5-231,511.3-231z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(58.538 44)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.925)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M511.9-230.3c-0.2,0.1-0.9-0.8-1.4-2.2s-0.6-2.5-0.4-2.5s0.6,1,1.1,2.3S512.1-230.4,511.9-230.3z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.696)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M512-231.1c-0.2,0.1-0.8-0.7-1.3-1.8s-0.8-2-0.7-2.1s0.8,0.7,1.3,1.8S512.2-231.2,512-231.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.322)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M510.8-228.4c0.1,0,0.1,0.2,0.1,0.6h-0.4c-0.2-1.1-0.4-2.2-0.4-3.3c-0.2-2.2-0.2-3.9,0-3.9      s0.5,1.7,0.7,3.9c0.1,1.1,0.1,2.2,0.1,3.3h-0.4C510.7-228.2,510.8-228.4,510.8-228.4z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.912 0.152)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M510.7-228.5c-0.2,0-0.5-1.4-0.6-3.2s-0.1-3.2,0.1-3.3s0.5,1.4,0.6,3.2S510.9-228.5,510.7-228.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.198 0.155)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M510.4-227.2c-0.2,0-0.4-1.7-0.4-3.9s0.1-3.9,0.3-3.9s0.4,1.7,0.4,3.9S510.6-227.2,510.4-227.2z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.192 0.478)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M510.4-228.4c-0.2,0-0.4-1.5-0.4-3.3s0.2-3.3,0.4-3.3s0.4,1.5,0.4,3.3S510.6-228.4,510.4-228.4z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.759 101.023)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M563.6-231.3c0,0.2-12-0.5-26.8-1.5s-26.8-2-26.8-2.2s12,0.5,26.8,1.5S563.7-231.5,563.6-231.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.136 123.643)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M510-228.1l5.9,19.3c2.1,7.2,8.1,12.7,15.5,14.1l36.9,7l10-0.3l-3.4-8.6l-34.4-13.6    c-2.7-0.6-4.9-2.7-5.6-5.4l-5.2-19.5L510-228.1z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.635 8.996)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M510-196.4l0.3-2.4l28.4-1.1l13.9-35.1l53,3.6l-17.9,39L510-196.4z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(58.332 18.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M515.1-230.7c-0.8,1.3-2.5,1.7-3.8,0.9s-1.7-2.5-0.9-3.8c0.8-1.3,2.5-1.7,3.8-0.9      C515.6-233.7,515.9-232,515.1-230.7z"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(273.722 103.1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 163.279)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.479)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M632.7-191.8c23.1-8.4,11.2-43.2,11.2-43.2l-117.3,10.7c-9.1-0.1-16.6,7.3-16.6,16.4c0,0,0,0.1,0,0.1l0,0     c0,9.1,7.4,16.5,16.5,16.5L632.7-191.8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 5.823)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 114.364)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.022)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M522.1-215.4l-0.2-11.6l22.3-7.9l0.9,16.2l-1.3,0.6c-5.6,2.6-28.7,13.1-33,13.5       C506.1-204.3,522.1-215.4,522.1-215.4z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 15.74)",
    className: "st16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M514.4-225.4c0,0-5.5,4.3-4.3,5s24.9-8.9,35-14.1l-0.2-0.5l-27.6,11.5       C517.4-223.5,515.7-225.9,514.4-225.4z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.02 15.594)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M545.2-235c-0.1,0.1-0.2,0.1-0.3,0.2l-1,0.5l-3.7,1.7c-3.1,1.4-7.5,3.3-12.4,5.3c-4.9,2-9.3,3.7-12.5,4.9       c-1.5,0.5-2.8,1-3.8,1.4l-1.1,0.4c-0.1,0-0.2,0.1-0.4,0.1c0.1-0.1,0.2-0.1,0.4-0.2l1-0.4l3.8-1.5c3.2-1.2,7.6-3,12.5-4.9       s9.2-3.8,12.4-5.2l3.7-1.6l1-0.4C545-234.9,545.1-235,545.2-235z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.19 25.092)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M513.3-232.5c-0.8-1.2-2-2-3.3-2.4C511.5-234.9,512.8-234,513.3-232.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.559 20.659)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M511.8-233.7c0,0.1-0.5-0.2-1-0.5s-0.9-0.7-0.8-0.8s0.5,0.2,1,0.5S511.8-233.8,511.8-233.7z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.913 19.716)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M511.8-234.3c0,0.1-0.4,0-0.9-0.2c-0.5-0.2-0.9-0.4-0.8-0.4s0.4,0,0.9,0.2       C511.4-234.6,511.8-234.4,511.8-234.3z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.787 17.968)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M512.2-235c0,0.1-0.4,0.3-1,0.6c-0.3,0.2-0.7,0.3-1.1,0.3c0-0.1,0.4-0.3,1-0.6       C511.4-234.8,511.8-235,512.2-235z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.368 16.448)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M512.4-235c0,0.1-0.4,0.5-1.1,0.8c-0.4,0.2-0.9,0.4-1.3,0.3c0.4-0.2,0.8-0.4,1.2-0.6       C511.6-234.6,512-234.8,512.4-235z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.49 19.445)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M514.4-234c-0.4,0.3-0.9,0.4-1.3,0.5c-0.5,0.1-1,0.2-1.5,0.3c-0.3,0-0.6,0-1,0c-0.2,0-0.4-0.1-0.5-0.3       c-0.1-0.2-0.1-0.4,0-0.6c0.8-0.9,2.2-1.2,3.3-0.5c0.3,0.2,0.6,0.4,0.8,0.7c0.1,0.2,0.2,0.3,0.2,0.3c-0.3-0.4-0.7-0.7-1.1-0.9       c-0.4-0.2-0.9-0.3-1.4-0.3c-0.6,0-1.2,0.3-1.5,0.8c-0.1,0.2,0,0.5,0.3,0.5c0.3,0,0.6,0,0.9,0c0.5,0,1-0.1,1.5-0.2       C513.9-233.9,514.4-234.1,514.4-234z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.988 17.498)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M510.6-231.9c-0.3-0.2-0.5-0.5-0.5-0.9c-0.1-0.4-0.1-0.8,0-1.1c0.1-0.5,0.4-0.9,0.8-1.1       c0.3-0.1,0.6,0.1,0.7,0.4c0.1,0.2,0.1,0.5,0,0.7c-0.1,0.4-0.2,0.7-0.3,1.1c-0.1,0.3-0.3,0.6-0.5,0.9c0,0,0.2-0.3,0.4-0.9       c0.1-0.3,0.2-0.7,0.2-1c0.1-0.4,0-0.9-0.4-0.8c-0.3,0.1-0.6,0.6-0.6,0.9c-0.1,0.3-0.1,0.7,0,1       C510.4-232.5,510.5-232.2,510.6-231.9z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.099 10.082)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M515.4-235c0,0-0.6,0.2-1.5,0.7c-2.4,1.3-3.8,3.8-3.7,6.5c0,1,0.3,1.6,0.2,1.6c-0.1-0.1-0.1-0.3-0.2-0.4       c-0.1-0.4-0.2-0.8-0.2-1.2c-0.3-2.8,1.2-5.5,3.8-6.7c0.4-0.2,0.8-0.3,1.2-0.4C515.1-235,515.3-235,515.4-235z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.83 2.323)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M510-235c1.4,2.8,2.6,5.6,3.6,8.5C512.2-229.3,511-232.1,510-235z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.066 18.122)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M516-235c-1.8,1.2-3.9,2.1-6,2.5c0-0.1,1.4-0.5,3-1.2C514.7-234.4,516-235.1,516-235z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.897 16.462)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M510.3-235c0.1,0,0,0.3,0,0.7s0,0.7,0,0.7s-0.2-0.3-0.2-0.7C510-234.7,510.2-235,510.3-235z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.443 13.929)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M510.5-235c0.1,0,0,0.3-0.1,0.6s-0.3,0.5-0.4,0.5s0-0.3,0.1-0.6C510.3-234.8,510.4-235,510.5-235z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.731 12.127)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M511-235c0,0.1-0.3,0.2-0.5,0.4s-0.4,0.5-0.5,0.5s0-0.4,0.3-0.7S511-235,511-235z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.625 11.101)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M510.5-235c0.1,0.1,0,0.2-0.2,0.3s-0.3,0.2-0.4,0.1s0-0.2,0.2-0.3C510.3-235,510.5-235,510.5-235z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.719)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 3.341)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M609-235l-65.5,1.2c-10.5,0.2-19.2,8.1-20.5,18.5l-13,105.5h35.6l10.9-91.2h51.6L609-235z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.443 118.305)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M510-234.8c0,0.2,7.8,0.4,17.4,0.4c9.6,0.1,17.2-0.2,17.4-0.2c1.1-0.1-7.8-0.4-17.4-0.4        S510-235,510-234.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(38.073)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M606.9-235c-0.1,0-0.2,0-0.3,0l-1,0l-3.7,0.1l-13.5,0.6l-44.7,2.3c-2.2,0.1-4.3,0.3-6.5,0.3       c-2.1,0-4.2,0.1-6.3,0.2c-2.1,0.1-4.1,0.3-6.1,0.5c-2,0.1-3.9,0.5-5.8,1.1c-1.8,0.6-3.4,1.6-4.8,2.9c-1.3,1.2-2.3,2.7-2.9,4.4       c-0.6,1.5-1,3.1-1.2,4.8c-0.2,1.5-0.3,3-0.3,4.5c0,2.6,0.5,5.2,1.5,7.6c0.8,1.8,2,3.4,3.6,4.6c1,0.8,2.1,1.4,3.3,1.7       c0.8,0.2,0.8,0.2,0-0.1c-1.1-0.4-2.2-1-3.2-1.8c-1.5-1.2-2.7-2.8-3.4-4.6c-1-2.4-1.5-4.9-1.4-7.5c0-1.5,0.1-3,0.4-4.4       c0.2-1.6,0.6-3.2,1.2-4.7c0.6-1.6,1.6-3,2.8-4.2c1.3-1.2,2.9-2.2,4.6-2.8c1.8-0.6,3.7-1,5.6-1.1c2-0.2,4-0.3,6-0.4       s4.1-0.2,6.3-0.2c2.1,0,4.3-0.2,6.5-0.3l44.7-2.5l13.5-0.8l3.7-0.3l1-0.1C606.7-234.9,606.8-235,606.9-235z"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(57.088 111.482)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M569.8-221.1l-5.7,17.8c-2.2,7.4-8.4,12.9-16,14.3l-33.1,9.2l-2.6-6.1L510-195l28.6-9.8    c2.8-0.6,5-2.7,5.8-5.5l11.4-24.8l14.4,8.8L569.8-221.1z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(95.672 68.179)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M545-233.6c-12.1,1.4-16,6.3-21,13.5c-2,3-3.7,6.2-4.9,9.6l-9.2,26l19.1,5.9l-0.6,21.2l-8.7,25.8l73.6,5.8    l-0.2-37.6l-0.5-22.7c0.7-8.6,2.5-26.8,1-31.1c-6.5-18.4-21-14.9-31.6-17.5c-2.2-0.5-12.8-0.4-14.6,0"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.072 68.937)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M574.3-234.6c0,0.2-14.4,0.4-32.1,0.4s-32.1-0.2-32.1-0.4s14.4-0.4,32.1-0.4     C559.9-235,574.3-234.8,574.3-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.999 81.78)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M574.3-234.6c0,0.2-14.4,0.4-32.1,0.4s-32.1-0.2-32.1-0.4s14.4-0.4,32.1-0.4     C559.9-235,574.3-234.8,574.3-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.644 96.514)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M578-234.6c0,0.2-15.2,0.4-34,0.4c-18.8,0-34-0.2-34-0.4s15.2-0.4,34-0.4C562.8-235,578-234.8,578-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.048 56.369)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.888 3.061)",
    className: "st13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M563.7-233.3c-1,5-1.4,10.4-3.1,15.1c-1.1,3.6-2.8,6.9-4.9,10c-3.2,4-7.5,6.9-12.5,8.4c-4.9,1.5-28.2,6.7-33.3,6.3      l42.7-20.2l5.2-21.3L563.7-233.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M578.1-231l-4.7,18.1c-1.9,7.5-7.8,13.4-15.4,15.2l-37.7,8.8l-10.4,0.1v-14.2l38-10.3     c2.8-0.7,4.9-3,5.5-5.8l3.7-15.9L578.1-231z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.789 2.28)",
    className: "st13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M510-235"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.885 16.464)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M580.8-234.6c0,0.2-15.9,0.4-35.4,0.4c-19.6,0-35.4-0.2-35.4-0.4s15.9-0.4,35.4-0.4     C565-235,580.8-234.8,580.8-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.822 28.719)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M586.4-234.6c0,0.2-17.1,0.4-38.2,0.4c-21.1,0-38.2-0.2-38.2-0.4s17.1-0.4,38.2-0.4     S586.4-234.8,586.4-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.794 42.169)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M590.4-234.8c0,0.2-18,0.5-40.2,0.7c-22.2,0.2-40.2,0.2-40.2,0s18-0.5,40.2-0.7     C572.4-235.1,590.4-235,590.4-234.8z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.339 56.007)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M574.3-234.6c0,0.2-14.4,0.4-32.1,0.4s-32.1-0.2-32.1-0.4s14.4-0.4,32.1-0.4     C559.9-235,574.3-234.8,574.3-234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(47.124 7.115)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M540.5-180.3c0-0.1,0-0.2,0-0.3l0.1-0.9c0.1-0.8,0.3-1.9,0.5-3.4c0.5-2.9,1.1-7.2,1.8-12.5     c0.7-5.3,1.6-11.7,2-19c0.1-3.6,0.4-7.5-1.4-11c-0.9-1.8-2.2-3.3-3.9-4.4c-1.7-1.1-3.7-1.9-5.7-2.2l0,0l0,0     c-2.3-0.6-4.8-0.4-7,0.5c-2.4,0.8-4.6,2-6.5,3.5c-0.4,0.3-0.7,0.7-1,1.1c-0.3,0.4-0.5,0.9-0.7,1.4c-0.4,0.9-0.8,1.9-1.1,2.9     c-0.5,2-1,4-1.3,6c-0.7,4-1.4,7.9-2.1,11.7c-1.4,7.5-2.6,14.4-3.7,20.6l-0.2-0.3l21.3,4.6l5.9,1.3l1.5,0.4     c0.2,0,0.3,0.1,0.5,0.2c-0.2,0-0.4,0-0.5-0.1l-1.5-0.3l-5.9-1.1l-21.4-4.3l-0.3-0.1l0-0.3c1.1-6.1,2.3-13.1,3.6-20.6     c0.7-3.8,1.3-7.7,2.1-11.7c0.3-2,0.7-4.1,1.3-6.1c0.3-1,0.7-2,1.1-3c0.2-0.5,0.5-1,0.8-1.4c0.3-0.5,0.7-0.9,1.1-1.3     c2-1.6,4.3-2.9,6.7-3.7c2.4-0.9,5-1.1,7.5-0.5l-0.1,0c2.2,0.3,4.2,1.1,6,2.3c1.7,1.2,3.1,2.8,4.1,4.7c0.5,0.9,0.8,1.9,1.1,2.8     c0.2,1,0.4,1.9,0.4,2.9c0,0.5,0.1,1,0.1,1.4c0,0.5,0,0.9,0,1.4c0,0.9-0.1,1.9-0.1,2.8c-0.5,7.3-1.4,13.7-2.2,19     c-0.8,5.3-1.5,9.6-2.1,12.5c-0.3,1.4-0.5,2.5-0.6,3.3l-0.2,0.9C540.6-180.5,540.6-180.4,540.5-180.3z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.209 28.265)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M510.7-186c0.1-0.6,0.1-1.3,0.1-1.9c0-1.3,0-3.1,0-5.3c0-4.4,0-10.6-0.1-17.3s-0.2-12.9-0.3-17.3     c-0.1-2.1-0.1-3.9-0.2-5.3c0-0.6,0-1.3-0.1-1.9c-0.1,0.6-0.1,1.3-0.1,1.9c0,1.3,0,3.1,0,5.3c0,4.4,0,10.6,0.1,17.3     c0.1,6.8,0.2,12.9,0.3,17.3c0.1,2.1,0.1,3.9,0.2,5.3C510.6-187.3,510.6-186.6,510.7-186z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.151 131.494)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M608.6-192.7l0.7-3.1l-28.6-3l-12.5-35.8L510-235l19.1,41.5L608.6-192.7z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.879 17.612)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M514.4-229.7c1.3-0.8,1.7-2.6,0.9-4c-0.8-1.3-2.6-1.7-4-0.9c-1.3,0.8-1.7,2.6-0.9,4c0,0,0,0,0,0     C511.3-229.3,513.1-228.9,514.4-229.7"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(109.509)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 10.384)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M516.5-234.8c-4.2,0.7-7.1,4.6-6.4,8.8c0.4,2.3,1.7,4.3,3.7,5.4c1.1,0.8,2.6,1,3.9,0.5     c1.1-0.7,1.8-1.8,2.1-3c1.2-3.9,0.9-8.2-0.9-11.9"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.661)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.377 13.541)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M533.5-167.2L533.5-167.2c-6.9,0-12.4-5.6-12.4-12.4c0,0,0-0.1,0-0.1c0-4.3,0.1-8,0.1-8      s-10-0.9-10.7-10.8c-0.7-9.9-0.4-32.7-0.4-32.7l0,0c11.1-5.6,24.4-4.8,34.8,2.2l1.5,1l-0.5,48.5      C545.8-172.7,540.3-167.2,533.5-167.2z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.167 42.556)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M510-230.5c4.6-0.2,9-1.7,12.7-4.5c0,0-2.6,7.3-12.5,7L510-230.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.256 31.335)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M511.9-234.9c0.2-0.1,6.3-0.9,5.7,6.3s-7.6,4.2-7.6,4C510-224.8,511.9-234.9,511.9-234.9z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.388 2.472)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M510-229.4c0,0,0.1,0.1,0.3,0.2c0.3,0.1,0.6,0.2,0.9,0.1c1-0.5,1.6-1.5,1.6-2.7c0.1-0.6,0-1.2-0.2-1.8       c-0.1-0.5-0.4-0.9-0.9-1c-0.3-0.1-0.6,0-0.8,0.3c-0.1,0.2-0.1,0.3-0.1,0.3c0,0-0.1-0.1-0.1-0.4c0.1-0.2,0.2-0.3,0.3-0.4       c0.2-0.1,0.5-0.2,0.7-0.1c0.6,0.2,1,0.6,1.2,1.2c0.3,0.6,0.3,1.3,0.3,2c-0.2,1.4-1,2.7-2.1,2.9c-0.4,0.1-0.8,0-1.1-0.3       C510-229.3,510-229.4,510-229.4z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M521.3-213.7c1.7-1,3.2-2.1,4.7-3.4c2.2,3.5,6.9,4.6,10.4,2.4c0.4-0.3,0.8-0.6,1.2-0.9     c0.1,2.1,1.9,3.7,4,3.6c0.6,0,1.1-0.2,1.6-0.5l0.1,11.4c-0.1,1.1,0.2,2.2,0.7,3.2c0.7,0.9,2.2,1.1,2.8,0.2     c-0.2-1.4-0.1-2.8,0.4-4.1c0.6-1.3,2.2-2.2,3.4-1.5c0.4-2.2,0.5-4.5,0.4-6.8c0-0.7,0.1-1.4,0.3-2.1c0.4-0.6,0.6-0.1,1.3-0.3     c2.1-0.5,3.7-2.4,3.9-4.6c0.1-2.2-0.9-4.3-2.7-5.5c-1.8-1.2-4-1.8-6.1-1.5c1.3-1.5,1.4-3.7,0-5.2c-1.4-1.4-3.3-2.1-5.2-1.9     c-1.9,0.1-4.1,1.2-4.3,3.1c-0.6-4.3-4.5-7.4-8.9-6.8c-3.4,0.4-6.1,3-6.7,6.4c-2.3-1-5.5-2.1-7.8-1.1c-2.7,1.1-4.6,3.6-4.8,6.6     c0,0-0.6,7.8,4.4,9.4C519.4-212.1,521.3-213.7,521.3-213.7z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.724 24.8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 5.224)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.323 1.761)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M510-233.7c0,0.8,0.6,1.4,1.3,1.4c0.7,0.1,1.4-0.5,1.4-1.2c0,0,0,0,0,0c0-0.8-0.6-1.4-1.3-1.4        C510.7-235.1,510.1-234.5,510-233.7C510-233.8,510-233.8,510-233.7z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M510-233.5c0.2,0.2,1.2-0.6,2.7-0.6c1.5,0,2.6,0.7,2.7,0.6c0.1-0.1-0.1-0.4-0.6-0.8       c-0.6-0.4-1.4-0.7-2.2-0.7c-0.8,0-1.5,0.2-2.2,0.7C510.1-234,509.9-233.6,510-233.5z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.648 0.278)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.269 1.832)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M510-233.7c0,0.8,0.6,1.4,1.3,1.4c0.7,0.1,1.4-0.5,1.4-1.2c0,0,0,0,0,0c0-0.8-0.6-1.4-1.3-1.4         C510.7-235.1,510.1-234.5,510-233.7C510-233.8,510-233.8,510-233.7z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M510-233.5c0.2,0.2,1.2-0.6,2.7-0.6c1.5,0,2.6,0.7,2.7,0.6c0.1-0.1-0.1-0.4-0.6-0.8        c-0.6-0.4-1.4-0.7-2.2-0.7c-0.8,0-1.5,0.2-2.2,0.7C510.1-234,509.9-233.6,510-233.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.465 0.369)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M513.8-222.6c-0.8-0.2-1.6-0.4-2.4-0.4c-0.4,0-0.7-0.1-0.8-0.4c0-0.4,0.1-0.8,0.3-1.1        c0.4-0.9,0.7-1.9,1.1-2.9c1.6-4.1,2.7-7.5,2.5-7.6s-1.6,3.2-3.1,7.4c-0.4,1-0.7,2-1.1,2.9c-0.2,0.5-0.3,1-0.2,1.5        c0.1,0.3,0.3,0.5,0.6,0.6c0.2,0.1,0.4,0.1,0.6,0.1C512.2-222.5,513-222.5,513.8-222.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.898 13.816)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M514.8-235c-0.2,0-0.2,1.6-1.6,2.8s-3.1,1-3.1,1.2c0,0.1,0.4,0.3,1.1,0.3c0.9,0,1.9-0.3,2.6-0.9        c0.7-0.6,1.2-1.4,1.3-2.3C515-234.6,514.9-235,514.8-235z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.277)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M510-233.9c0.1,0.4,1.6,0.2,3.4,0.4c1.8,0.2,3.2,0.7,3.4,0.3c0.1-0.2-0.1-0.6-0.7-0.9       c-1.5-1-3.4-1.2-5.2-0.6C510.3-234.4,509.9-234.1,510-233.9z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.532 0.823)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M510-233.5c0.3,0.3,1.3,0,2.5,0c1.2-0.1,2.3,0.2,2.5-0.1c0.1-0.2-0.1-0.5-0.5-0.8       c-1.3-0.8-2.9-0.7-4.1,0.1C510.1-234,509.9-233.6,510-233.5z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.099 5.688)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M516.7-230.5c0,0-0.1-0.1-0.4-0.1c-0.4-0.1-0.7,0-1,0.3c-0.5,0.4-0.6,1-0.5,1.5c0.2,0.7,0.8,1.3,1.5,1.6     c0.9,0.3,1.8,0.3,2.7-0.2c0.9-0.6,1.5-1.5,1.6-2.6c0.1-1.2-0.3-2.3-1.2-3.1c-0.9-0.9-2.2-1.3-3.5-1.1c-1.3,0.2-2.5,0.7-3.4,1.7     c-0.8,0.9-1.4,2-1.6,3.2c-0.4,2.1,0,4.2,1,6c0.7,1.2,1.7,2.3,2.8,3.2c0.8,0.6,1.3,0.8,1.3,0.9c-0.5-0.1-1-0.3-1.5-0.6     c-1.3-0.8-2.3-1.9-3.1-3.1c-1.2-1.9-1.6-4.2-1.2-6.4c0.2-1.3,0.9-2.6,1.8-3.5c1-1.1,2.4-1.7,3.8-1.9c1.5-0.2,3,0.3,4.1,1.3     c1,0.9,1.6,2.3,1.4,3.7c-0.1,1.3-0.9,2.4-2,3c-1,0.5-2.1,0.5-3.2,0.1c-0.8-0.4-1.5-1.1-1.7-2c-0.2-0.7,0.1-1.4,0.7-1.8     c0.4-0.2,0.8-0.3,1.2-0.2C516.6-230.7,516.7-230.5,516.7-230.5z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(49.583 423.77)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 74.005)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M548.9-161.3c0.9-3.7-1.5-7.4-4.2-10s-6-5-7.4-8.5c-2.3-5.7,0.7-13.1-3.2-17.9c-2.3-2.8-6.4-3.7-8.5-6.7    c-0.9-1.7-1.6-3.5-1.9-5.3c-2.2-9.5-6.9-18.2-13.7-25.2c-0.4,8.5,1.5,16.9,5.4,24.4c1.6,3,3.5,5.9,4.1,9.2    c0.9,5.4-2.1,11-0.8,16.4c1.6,6.1,8.4,10.1,8.8,16.4c0.3,5.3-4.3,10-3.9,15.3c0.3,2.3,1.1,4.4,2.4,6.3    c4.1,6.8,10.2,11.5,19.3,11.3l11.2,0.3L548.9-161.3z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 74.005)",
    className: "st13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M548.9-161.3c0.9-3.7-1.5-7.4-4.2-10s-6-5-7.4-8.5c-2.3-5.7,0.7-13.1-3.2-17.9c-2.3-2.8-6.4-3.7-8.5-6.7    c-0.9-1.7-1.6-3.5-1.9-5.3c-2.2-9.5-6.9-18.2-13.7-25.2c-0.4,8.5,1.5,16.9,5.4,24.4c1.6,3,3.5,5.9,4.1,9.2    c0.9,5.4-2.1,11-0.8,16.4c1.6,6.1,8.4,10.1,8.8,16.4c0.3,5.3-4.3,10-3.9,15.3c0.3,2.3,1.1,4.4,2.4,6.3    c4.1,6.8,10.2,11.5,19.3,11.3l11.2,0.3L548.9-161.3z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.557)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.606 35.056)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M515.8-96.2c1,0.2,2.1,0.1,3.1-0.1c1.2-0.2,2.5-0.5,3.6-0.9c1.6-0.6,3.1-1.4,4.5-2.5     c0.8-0.7,1.4-1.5,1.8-2.5c0.3-1.1,0.5-2.2,0.5-3.3c0-1.2,0.1-2.4,0.2-3.6c0.2-1.3,0.7-2.5,1.3-3.6c1.3-2.3,3.5-4.5,4.2-7.7     c0.7-3.1,0.2-6.5-0.4-9.8c-0.5-3.4-1.1-7,0.2-10.5c1.2-3.5,3.6-6.7,4.8-10.6c1.2-4,0.6-8.3,0.8-12.5c0.1-2.1,0.5-4.3,1.4-6.2     c0.9-2,2.1-3.9,3.1-6c2-4.2,2.3-9,2.8-13.7c0.3-2.4,0.5-4.7,0.8-7.2c0.2-2.4,0.6-4.8,1.2-7.2c0.7-2.4,1.6-4.7,2.6-6.9     c0.5-1.2,1-2.4,1.3-3.6c0.2-1.3,0.3-2.6,0.3-3.9c0.1-2.6,0-5.2-0.3-7.8c-0.3-2.6-0.8-5.1-1.1-7.7l-0.1-0.4l-0.1-0.5l-0.5,0.2     c-2.4,1.2-4.4,3-6,5.1c-1.5,2.1-2.8,4.4-3.7,6.8c-1.8,4.8-2.5,9.9-3.4,14.7c-0.9,4.8-2.1,9.6-4.5,13.6c-1.2,2-2.7,3.8-4,5.8     c-1.4,1.9-2.3,4.1-2.7,6.4c-0.6,4.7,2,8.9,1.5,13.1c-0.2,2.1-0.9,4-2,5.8c-1,1.8-2.2,3.5-3.3,5.1c-1.1,1.6-2.1,3.4-3,5.2     c-0.8,1.8-1.2,3.7-1.3,5.6c-0.3,3.8,0.3,7.4,0,10.7c-0.3,3.2-1.2,6.4-2.7,9.2c-1.3,2.8-2.8,5.3-4.1,7.7     c-0.6,1.2-1.2,2.4-1.7,3.6c-0.4,1.1-0.8,2.3-1,3.5c-0.3,2.1-0.3,4.3,0,6.4c0.3,3,1.4,5.8,3.3,8.1c0.3,0.4,0.6,0.7,0.9,1     c0.2,0.2,0.5,0.4,0.7,0.6C515.5-96.3,515.7-96.2,515.8-96.2c-0.8-0.6-1.5-1.3-2.2-2.1c-1.7-2.4-2.8-5.2-3.1-8.1     c-0.3-2.1-0.2-4.2,0.1-6.3c0.2-1.2,0.5-2.3,1-3.5c0.5-1.2,1.1-2.3,1.7-3.5c1.3-2.4,2.8-4.9,4.1-7.7c1.5-2.9,2.5-6.1,2.8-9.4     c0.3-3.5-0.3-7,0-10.7c0.1-1.9,0.6-3.7,1.3-5.4c0.8-1.8,1.8-3.5,2.9-5.1c1.1-1.7,2.3-3.3,3.4-5.2c1.1-1.8,1.8-3.9,2.1-6.1     c0.5-4.5-2.1-8.6-1.5-13.1c0.4-2.2,1.3-4.3,2.6-6.1c1.3-1.9,2.8-3.7,4-5.8c2.5-4.1,3.7-9,4.6-13.8c0.9-4.8,1.6-9.8,3.4-14.6     c0.9-2.4,2.1-4.6,3.6-6.7c1.5-2.1,3.5-3.7,5.7-4.9l-0.5-0.3l0.1,0.5c0.3,2.6,0.8,5.2,1.1,7.7c0.3,2.5,0.4,5.1,0.3,7.6     c0,1.3-0.2,2.5-0.3,3.7c-0.3,1.2-0.7,2.4-1.2,3.5c-1,2.3-1.9,4.6-2.7,7c-0.7,2.4-1.1,4.8-1.2,7.3c-0.3,2.4-0.5,4.8-0.8,7.2     c-0.5,4.7-0.8,9.4-2.7,13.5c-0.9,2-2.2,3.9-3.1,6c-0.9,2-1.4,4.2-1.5,6.5c-0.2,4.3,0.4,8.5-0.8,12.4c-1.1,3.8-3.6,7-4.8,10.6     c-1.3,3.7-0.7,7.4-0.2,10.8c0.6,3.4,1.1,6.6,0.4,9.6c-0.6,3-2.7,5.2-4.1,7.6c-0.7,1.1-1.2,2.4-1.4,3.8c-0.1,1.2-0.2,2.4-0.2,3.7     c0,1.1-0.1,2.2-0.5,3.3c-0.4,0.9-1,1.7-1.7,2.4c-1.3,1.1-2.8,1.9-4.4,2.5c-1.2,0.4-2.4,0.8-3.6,1c-0.8,0.1-1.5,0.2-2.3,0.2     C516-96.2,515.8-96.2,515.8-96.2z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.746 6.693)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M544.6-235c-0.1,0.1-0.1,0.2-0.1,0.3c-0.1,0.3-0.1,0.6-0.2,1c-0.2,0.9-0.5,2.2-0.9,3.9      c-0.4,1.7-1.4,3.5-2.3,5.9c-0.9,2.3-1.8,5-2.6,8c-0.8,3-1.6,6.3-2.3,9.9c-0.8,3.5-1.6,7.4-3.5,11c-0.9,1.8-1.9,3.7-2.7,5.7      c-0.8,2.1-1.3,4.2-1.6,6.4c-0.5,4.6-1.3,9.1-2.3,13.6c-2.2,9.2-4.3,17.9-6.2,25.9c-1.9,7.9-3.7,15.1-5.2,21.1      c-1.4,6-2.6,10.8-3.4,14.3c-0.4,1.6-0.7,2.9-0.9,3.9c-0.1,0.4-0.2,0.7-0.2,1c0,0.1,0,0.2,0,0.4c0.1-0.1,0.1-0.2,0.1-0.3l0.3-1      c0.2-0.9,0.6-2.2,1-3.9c0.9-3.4,2.1-8.3,3.7-14.2c1.5-6,3.3-13.2,5.3-21.1l6.2-25.9c1-4.5,1.8-9,2.3-13.6      c0.2-2.1,0.8-4.3,1.5-6.3c0.8-2,1.8-3.8,2.7-5.6c2-3.7,2.7-7.6,3.5-11.1c0.7-3.6,1.5-6.9,2.3-9.9s1.7-5.6,2.5-7.9      c0.8-2.3,1.8-4.2,2.2-5.9c0.4-1.7,0.6-3,0.8-3.9c0.1-0.4,0.1-0.8,0.2-1C544.6-234.8,544.6-234.9,544.6-235z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M551.3-61.1c7.3-4.4,9.3-17.6,6.2-25.5s-8.5-15.1-9.3-23.6c-0.7-6.5,1.4-13.2-0.1-19.6    c-2.1-8.6-10.5-15.2-10.5-24c0-5,2.8-9.6,2.6-14.6c-0.3-6.1-5-10.9-7.9-16.2c-4.5-8.2-4.8-17.8-6.4-27s-5.1-19-13.3-23.4    c-1.2,7.8-3.2,13.1-2.5,23.7c0.3,3.8,4.7,11,5.3,19.3c0.4,5,0.7,9.9,1,14.9c0.3,4.8,0.7,9.8,2.4,14.3c1.3,3.5,3.5,6.6,4.5,10.2    c1.9,6.7-0.5,14,1,20.8c1.3,5.8,5.3,10.7,6.2,16.6c1.2,8.2-4.1,16.8-1.3,24.6c1.4,3.9,4.6,7,5.5,11c0.7,3.1,0,6.4,0.6,9.6    c1.1,5,10.7,8.9,15.9,8.6"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.673 7.721)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M510-235c0,0.1,0,0.3,0,0.4c0,0.3,0.1,0.7,0.2,1.3c0.2,1.1,0.4,2.8,0.8,4.9c0.4,2.1,1.5,4.6,2.4,7.5     c0.9,2.9,1.9,6.3,2.7,10s1.6,7.9,2.3,12.4c0.8,4.4,1.6,9.3,3.8,14c1,2.3,2.2,4.7,3.1,7.2c0.9,2.6,1.4,5.2,1.6,7.9     c0.4,5.7,1.2,11.4,2.2,17c2.3,11.5,4.5,22.5,6.5,32.5c2.1,10,4,18.9,5.6,26.5c1.6,7.5,2.9,13.6,3.8,17.8     c0.5,2.1,0.8,3.7,1.1,4.8l0.3,1.3c0,0.1,0.1,0.3,0.1,0.4c0-0.1,0-0.3-0.1-0.4c-0.1-0.3-0.1-0.7-0.2-1.3     c-0.2-1.2-0.5-2.8-0.9-4.9c-0.9-4.3-2.1-10.4-3.6-17.9c-1.6-7.6-3.4-16.5-5.4-26.5c-2-10-4.2-21-6.4-32.5     c-1-5.6-1.8-11.3-2.2-17c-0.2-2.7-0.8-5.4-1.6-8.1c-0.9-2.5-2.1-4.9-3.1-7.2c-2.2-4.6-3-9.4-3.8-13.8c-0.8-4.5-1.5-8.6-2.4-12.4     c-0.9-3.8-1.9-7.1-2.9-10c-0.9-2.9-2.1-5.3-2.5-7.4c-0.4-2.1-0.7-3.8-0.9-4.9c-0.1-0.5-0.2-0.9-0.2-1.3     C510.1-234.7,510.1-234.9,510-235z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1041.264 93.142)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.48)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M524.8-202.2c-2.2,3.2-6.5,2.1-8.5,0.2s-2.8-4.7-3.6-7.4c-1.7-6.1-3.5-12.5-2.2-18.7     c0.3-1.9,1.1-3.6,2.4-5.1c1.3-1.4,3.2-2.1,5.1-1.7c2.2,0.6,3.5,2.7,4.5,4.7c2.9,6,4.4,12.5,4.4,19.1     C526.8-208,526.5-204.8,524.8-202.2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.48)",
    className: "st22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M524.8-202.2c-2.2,3.2-6.5,2.1-8.5,0.2s-2.8-4.7-3.6-7.4c-1.7-6.1-3.5-12.5-2.2-18.7c0.3-1.9,1.1-3.6,2.4-5.1     c1.3-1.4,3.2-2.1,5.1-1.7c2.2,0.6,3.5,2.7,4.5,4.7c2.9,6,4.4,12.5,4.4,19.1C526.8-208,526.5-204.8,524.8-202.2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 46.961)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M529-233.2c-3.7-1.7-7.9-2.2-11.9-1.4c-2.2,0.4-4.4,1-5.9,2.6s-1.7,4.5-0.1,5.9c1.1,0.7,2.4,1.1,3.7,0.9     c3.1,0,6.6-0.6,9.1,1.3c1.4,1.1,2.4,2.9,4.1,3.4c1.8,0.4,3.6-0.4,4.4-2c0.8-1.6,1-3.4,0.5-5.1C532.6-230,531.1-232.1,529-233.2z     "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.968 10.15)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M512.3-207.9c-2.3-3-3-7-1.8-10.6c1.2-3.5,3.4-6.7,6.3-9.1c3.3-2.9,7.1-5.2,11.2-6.6     c1.6-0.6,3.3-0.9,5-0.9c1.7,0.1,3.3,1.1,4.2,2.6c1.2,2.2,0,5-1.2,7.2c-2.2,3.9-4.6,7.7-7.4,11.2c-2.2,2.8-4.7,5.6-8.1,6.9     s-6.9,1.1-8.6-1.2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.896 51.34)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M526.5-206c-0.1-0.5-0.2-1-0.2-1.4c-0.1-1-0.2-2.4-0.4-3.9c-0.2-1.9-0.5-3.8-0.9-5.7     c-0.5-2.3-1.2-4.6-2.1-6.8c-0.9-2.2-2-4.3-3.5-6.1c-1.2-1.5-2.7-2.8-4.4-3.6c-1.2-0.6-2.4-1-3.7-1.1c-0.5,0-1-0.1-1.4-0.2     c0.5-0.1,1-0.1,1.5,0c1.3,0.1,2.6,0.4,3.8,1c1.8,0.8,3.4,2.1,4.6,3.7c1.5,1.9,2.7,4,3.6,6.3c0.9,2.2,1.6,4.5,2.1,6.9     c0.4,1.9,0.6,3.9,0.8,5.8c0.1,1.7,0.2,3,0.2,3.9C526.6-207,526.5-206.5,526.5-206z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.784 12.676)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M517.3-170.3c0-0.2-0.1-0.4,0-0.7c0-0.5,0-1.1,0-1.9c0-1.6,0-4-0.1-7c-0.1-5.9-0.7-14-1.6-23     s-2.3-17-3.5-22.8c-0.3-1.4-0.6-2.8-0.8-3.9s-0.5-2.1-0.7-2.9c-0.2-0.8-0.3-1.4-0.4-1.8c-0.1-0.2-0.1-0.4-0.1-0.7     c0.1,0.2,0.2,0.4,0.2,0.6c0.1,0.5,0.3,1.1,0.6,1.8c0.2,0.8,0.5,1.8,0.8,2.9s0.6,2.4,0.9,3.9c1.6,7.5,2.9,15.1,3.7,22.8     c1,9,1.4,17.1,1.5,23.1c0,3,0,5.4-0.1,7c0,0.8-0.1,1.4-0.1,1.9C517.4-170.8,517.4-170.6,517.3-170.3z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.046 17.492)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M510-190.9c0-0.7,0-1.3,0-2c0.1-1.3,0.2-3.1,0.6-5.4c0.4-2.6,1-5.3,1.8-7.8c0.9-3.2,2-6.3,3.3-9.3     c2.3-5.5,5.5-10.6,9.6-15c0.7-0.7,1.5-1.5,2.3-2.1c0.3-0.3,0.7-0.6,1-0.8l0.9-0.6c0.5-0.4,1.1-0.8,1.7-1.1     c-1.9,1.5-3.8,3.1-5.5,4.9c-4,4.4-7.1,9.5-9.4,14.9c-1.3,3-2.4,6.1-3.3,9.2c-0.9,2.9-1.4,5.5-1.9,7.8c-0.4,2.2-0.6,4.1-0.8,5.3     C510.2-192.2,510.2-191.6,510-190.9z"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M983.6-109.1c0.7,0.6,1.4,1.1,1.9,1.9c0.8,1.2,1.6,2.4,2.5,3.8c-1.4,0.3-2.4,0.2-3-1.1   c-0.6-1.1-1.4-2.1-2.1-3.2c-0.3-0.5-0.7-0.9-1.2-1.1c-1-0.5-2.2-0.5-3.1-0.1c-0.7,0.3-0.3,1.4-0.3,2.1c-0.1,0.9,0,1.8,0,2.8   c0,0.6-0.1,0.8-0.8,0.8c-0.6,0-0.9-0.2-0.9-0.9c0-3.8,0-7.7,0-11.5c0-0.6,0.1-0.9,0.8-0.8c2.1,0,4.3-0.1,6.4,0.1   c2,0.2,3,1.3,3.3,3.1c0.2,1.8-0.6,3.2-2.5,3.9C984.2-109.3,983.9-109.2,983.6-109.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M1041.6-113.1c2.6,0,3.5,0.9,3.6,3.5c0.1,1.9-0.2,3.8,0.2,5.7c0.1,0.2,0.2,0.6-0.1,0.6   c-0.4,0.1-1.1,0.3-1.3-0.2c-0.4-1-0.8-0.5-1.3-0.2c-0.9,0.6-2,0.8-3.1,0.7c-1.5-0.2-2.5-1.2-2.7-2.5c-0.1-1.3,0.7-2.6,2.1-3   c1.1-0.3,2.3-0.4,3.5-0.6c0.4-0.1,1-0.1,1.1-0.7c0.1-0.6-0.2-1.1-0.7-1.4c-1.2-0.7-3.2-0.4-3.8,0.8c-0.4,0.8-0.9,0.7-1.4,0.5   c-0.8-0.4-0.1-1,0.1-1.4C1038.4-112.5,1039.8-113.1,1041.6-113.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M1005.9-107.6c0.1,1.1,0.1,2.2,0.2,3.4c0,0.3,0.4,0.8,0,0.9c-0.4,0.1-1.1,0.4-1.3-0.3   c-0.3-0.9-0.7-0.4-1.1-0.2c-1,0.7-2.1,0.9-3.2,0.8c-1.5-0.2-2.5-1.2-2.7-2.5c-0.1-1.3,0.7-2.6,2.1-3c1.1-0.3,2.3-0.4,3.5-0.6   c0.5-0.1,1.1-0.1,1.1-0.8c0-0.6-0.3-1.1-0.8-1.4c-1.3-0.7-3-0.3-3.7,0.9c-0.4,0.8-0.9,0.5-1.4,0.3c-0.8-0.3-0.2-0.8-0.1-1.1   c0.6-1.5,2.9-2.3,5.1-1.9c1.8,0.4,2.5,1.2,2.5,3.2C1006-109.1,1006-108.3,1005.9-107.6C1005.9-107.6,1005.9-107.6,1005.9-107.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M988.2-107.7c0.1-3,1.2-4.6,3.3-5.2c2.9-0.8,5.8,1.6,5.5,4.6c-0.1,0.8-0.5,0.7-1,0.7c-1.7,0-3.5,0-5.2,0   c-0.9,0-1,0.4-0.8,1c0.3,1.1,1,1.8,2.1,2c1.1,0.2,2.1,0,2.7-1c0.5-0.9,1.2-0.9,1.7-0.5c0.6,0.5-0.1,1.1-0.4,1.5   c-1.1,1.4-2.6,1.7-4.3,1.4c-1.7-0.3-2.9-1.3-3.4-3C988.3-106.7,988.3-107.4,988.2-107.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M1028.9-113.4c1.6,2.3,3.2,4.6,4.7,6.9c0.1,0,0.2,0,0.3,0c0-2.5,0-5,0-7.5c0.2-0.4-0.1-1.1,0.6-1.2   c0.7-0.2,0.6,0.6,0.9,0.9c0,3.3,0.1,6.6,0.1,9.9c0,0.4,0.3,1-0.5,1.1c-0.6,0.1-1.2,0.2-1.6-0.5c-1.9-2.9-3.8-5.8-5.7-8.7   C1027.5-113.5,1028.2-113.5,1028.9-113.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M1069.5-107.6c-1.3,0-2.7,0.1-4,0c-1.1-0.1-1.1,0.5-0.8,1.2c0.4,1,1.1,1.6,2.1,1.8c1.1,0.2,2.1,0,2.7-1   c0.5-0.9,1.2-0.8,1.7-0.4c0.6,0.4-0.1,1-0.3,1.4c-1.1,1.7-3.8,2.1-5.8,1.1c-1.6-0.9-2.5-2.9-2.1-5.3c0.3-2.3,1.4-3.6,3.3-4.1   c1.3-0.3,2.5-0.2,3.6,0.8c0.1,0.6-0.4,0.5-0.7,0.5c-0.5,0-1,0.1-1.4,0.3c-0.6,0.2-1.4,0.2-1.9,0.7c-0.6,0.5-0.9,1,0,1.5   c0.2,1.3,1.3,0.9,2.1,0.9C1068.4-108.2,1069.2-108.5,1069.5-107.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M1058.1-105.3c0.8-2.3,1.5-4.2,2.2-6.1c0.5-1.3,0.5-1.3,2.1-1.2c-1.1,3-2.2,5.9-3.3,8.9   c-0.2,0.5-0.5,0.5-1,0.5c-0.5,0-0.9,0-1.1-0.6c-1.1-2.9-2.2-5.8-3.3-8.7c1.2-0.4,1.8-0.1,2.1,1   C1056.5-109.6,1057.3-107.7,1058.1-105.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M1018.3-115.9c0,0.6,0,1.1,0,1.6c0,0.7-0.2,1.6,1.1,1.5c0.5-0.1,0.5,0.4,0.5,0.7c0,0.5-0.1,0.8-0.7,0.8   c-0.9-0.1-1,0.4-1,1.1c0,1.2,0,2.4,0,3.7c0,0.9-0.3,2,1.3,2c0.4,0,0.4,0.5,0.5,0.8c0,0.5-0.3,0.6-0.7,0.6   c-1.5,0.3-2.6-0.5-2.6-2.1c-0.1-1.7,0-3.4,0-5c0-0.5,0.1-1.2-0.8-1.1c-0.4,0-0.4-0.3-0.4-0.6c0-0.3-0.1-0.8,0.4-0.8   c0.9,0,0.8-0.6,0.8-1.1C1016.5-115,1016.9-115.6,1018.3-115.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M1050.3-112.1c-2.3,1.8-1,4.4-1.3,6.6c-0.1,0.7,0.3,1,1,1c0.7,0,0.7,0.5,0.7,1c0,0.6-0.5,0.5-0.9,0.6   c-1.5,0.1-2.3-0.5-2.4-2.1c-0.1-1.4,0-2.9-0.1-4.3c0-0.8,0.6-1.9-1-2.1c-0.3,0-0.5-1.2,0.2-1.3c1-0.2,0.9-0.7,0.8-1.3   c-0.1-1.1,0.5-1.5,1.6-1.9c0,1.1,0,2.1,0,3.1C1049.2-112.3,1050-112.7,1050.3-112.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M1009-107c0.1,1.4,0.9,2.1,2.1,2.4c1.2,0.3,2.3-0.2,2.7-1.4c0.3-0.9,0.8-0.6,1.3-0.4   c0.8,0.3,0.3,0.8,0.2,1.2c-0.7,1.6-2.6,2.5-4.5,2.1c-2.1-0.4-3.2-1.9-3.3-4.1c-0.2-0.6-0.2-1.1,0-1.7l0,0c0.6-0.4,1.1-0.2,1.3,0.5   C1009-107.9,1008.8-107.4,1009-107z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M1008.7-108.2c-0.3-0.4-0.7-0.7-1.2-0.6c0-1.7,0.7-3.1,2.3-3.8c1.6-0.8,3.2-0.6,4.5,0.6   c0.4,0.3,0.7,0.7,0.8,1.2c0.1,0.4,0.3,0.7-0.2,0.8c-0.3,0.1-0.7,0.3-1.1-0.1c-2.1-2.3-3.7-2-4.7,1   C1008.7-108.8,1009-108.4,1008.7-108.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M1051.4-108.2c0-1.3,0-2.5,0-3.8c0-0.6,0.2-0.8,0.8-0.8c0.6,0,0.8,0.2,0.8,0.8c0,2.6,0,5.3,0,7.9   c0,0.6-0.2,0.8-0.8,0.8c-0.6,0-0.8-0.2-0.8-0.8C1051.4-105.4,1051.4-106.8,1051.4-108.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M1025.3-103.6c-0.1-4.2-0.1-8.4,0-12.6c1.3,0.7,1.3,2.1,1.3,3.3c0.1,2.8,0,5.6,0.1,8.4   C1026.7-103.4,1026.2-103.2,1025.3-103.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M1067.6-111.6c0.5-1.1,1.5,0,2.2-0.6c1.4,0.9,1.8,2.3,1.8,3.8c-0.1,1.6-1.4,0.5-2.1,0.7   c-1.3-0.5-2.6-0.1-4-0.3c0.6-0.4,0.6-0.8,0-1.1c1-0.8,2.1-0.4,3.1-0.4c0.3-0.1,0.5,0.6,0.8,0.1   C1069.3-110.5,1068.2-110.8,1067.6-111.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M1025.3-103.6c0.9,0.1,1.3-0.2,1.3-1.2c-0.1-2.5,0.1-5-0.1-7.5c-0.1-1.3-0.8-2.6-1.2-3.9   c0.8-0.6,1.5-0.5,2.1,0.4c0.5,0.8,1,1.6,1.5,2.4c-0.4,0.3-1.2,0.2-1.2,0.9c-0.2-0.3-0.5-0.5-0.9-1c0,3.2,0,6.1,0,9   C1026.9-103.1,1026.4-102.9,1025.3-103.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M1035.4-114.3c-0.7-1.2-1.2-0.7-1.5,0.3c0-0.4-0.1-0.7,0-1c0.1-0.5-0.4-1.3,0.4-1.3c0.9-0.1,1.3,0.6,1.1,1.5   C1035.5-114.7,1035.4-114.5,1035.4-114.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M1052.1-114.9c-0.6,0.1-0.8-0.2-0.8-0.8c0-0.6,0.3-0.7,0.8-0.7c0.6,0,0.8,0.3,0.8,0.8   C1053-115,1052.7-114.9,1052.1-114.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M1050.3-112.1c-0.6,0-1.2,0-1.3-0.7c0.4,0,0.8,0,1.1,0.1C1050.6-112.7,1050.7-112.5,1050.3-112.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M1008.7-108.2c0-0.3,0-0.7,0.3-0.9c0,0.7,0,1.4,0,2.1C1008.6-107.3,1008.8-107.8,1008.7-108.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M1007.5-108.8c0,0.6,0,1.1,0,1.7C1007.2-107.7,1007.2-108.3,1007.5-108.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M980.9-114.9c0.8,0,1.5-0.1,2.3,0c1.1,0.2,1.9,0.8,1.9,2c0,1.1-0.7,1.8-1.7,2.1c-1.6,0.3-3.2,0.1-4.7,0.1   c-0.4,0-0.5-0.2-0.5-0.6c0-1,0-2,0-3.1c0-0.6,0.3-0.7,0.8-0.7C979.6-114.9,980.3-114.9,980.9-114.9   C980.9-114.9,980.9-114.9,980.9-114.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M1040.7-104.5c-0.9-0.1-1.8-0.2-2-1.3c-0.1-1.1,0.8-1.3,1.6-1.5c0.7-0.1,1.4-0.3,2.1-0.3   c0.4,0,0.8-0.5,1.1-0.1c0.3,0.4,0.2,1,0,1.5C1043-104.9,1041.9-104.6,1040.7-104.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M1004.3-107.8c0.1,2.4-1.6,3.8-3.7,3.2c-0.6-0.2-1.1-0.5-1.2-1.2c0-0.7,0.4-1.2,1-1.3   C1001.7-107.4,1003-107.6,1004.3-107.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M992.6-109.1c-0.4,0-0.8,0-1.2,0c-0.5-0.1-1.1,0.3-1.3-0.3c-0.2-0.6,0.3-1,0.7-1.4c1.2-1.2,3.4-0.9,4.2,0.5   c0.4,0.8,0.5,1.4-0.7,1.3C993.7-109.1,993.1-109.1,992.6-109.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M1067.6-111.6c1.2,0.4,2.3,1,2.1,2.5c-0.2,0.2-0.4,0.2-0.6,0.1c-1.2,0-2.5,0-3.7,0c-0.9,0-1.1-0.4-0.7-1.2   C1065.4-111.3,1066.5-111.6,1067.6-111.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M1068.2-108.5c-0.4,0-0.8,0-1.4,0C1067.4-108.9,1067.8-108.8,1068.2-108.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M1069.2-109c0.2,0,0.4,0,0.6-0.1c0.3,0.3,0,0.4-0.2,0.5C1069.3-108.5,1069.2-108.8,1069.2-109z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M998.6-147.4c-2.8-0.7-5.4-1.8-7.9-3.2c-0.3-0.3-0.4-0.7-0.5-1c-0.1-0.5-0.5-0.5-0.8-0.6   c-0.5-0.5-1-0.7-1.7-0.8c-0.5-0.1-1.1-0.3-1-0.9c0.1-0.6,0.6-0.6,1.1-0.6c0.8,0,1.5-0.1,2.3-0.1c0.6,0.9,1.4-0.3,2.1,0.1   c2.1,0.7,4.1,1.8,6.2,2.5c1.2,0.4,1.7,0.1,2.1-1.1c0.7-2.4,1.6-4.7,2.6-7c0.5-1.1,0.5-2,0-3.1c-1.1-2.4-2-4.9-2.8-7.5   c-0.2-0.7-0.5-1.1-1.3-0.8c-4.2,1.5-8.2,3.1-11.5,6.3c-1.2,1.2-2,2.6-2.2,4.3c-0.3,0.9-0.6,1.6-1.6,0.6c-0.8-0.8-1.6,0.4-2.4,0.1   c-0.6-2.8,0.5-5.1,2.3-7.1c3.2-3.6,7.3-5.6,11.7-7.3c0.4-0.2,0.8-0.3,1.1-0.4c2.5-0.9,2.5-0.9,2.3-3.5c-0.2-0.5-0.2-1.1,0.2-1.2   c1.4-0.4,0.6-1.3,0.5-2c-0.3-2,0.6-2.9,2.5-2.7c0.8,1.5,0.6,3.3,1,4.9c0.5,2,0.4,2,2.4,1.6c2.2-0.4,4.5-1,6.8-1.1   c1.4-0.1,2.3-0.7,3.1-1.9c1.4-2,2.9-3.9,4.7-5.6c0.4-0.4,0.8-0.9,0.7-1.6c0-0.8-0.3-1.4-1.2-1.3c-0.4-0.1-0.8-0.3-1-0.7   c-0.1-0.5-0.6-0.7-1-0.8c-2.4-1.4-4.8-2.8-7.2-4.1c-1-1.3-1.3-3.1-2.9-3.9c-0.3-0.1-0.4-0.4-0.2-0.8c0.8,0.3,1.6,0.1,2.5,0.3   c0.5,1,1.2,1.7,2.5,1.1c0.3-0.1,0.6,0.1,0.9,0.1c3.9,1.5,7.2,4.1,10.2,6.8c0.9,0.8,1.4,0.7,2.2-0.1c1.6-1.5,3.4-3,5.3-4.1   c1.6,0.3,2.2,1.6,2.7,2.9c-0.1,0.6-0.7,0.9-1.1,1.2c-1.1,0.8-2.2,1.7-3.3,2.5c-1.4,1.2-1.4,1.2-0.2,2.6c1.7,1.8,3.2,3.7,4.7,5.7   c0.7,0.9,1.5,1.5,2.6,1.6c2.6,0.2,5.1,0.7,7.7,1.3c1.1,0.2,1.5-0.2,1.7-1.2c0.6-3.8,1.2-7.6,0.4-11.4c-0.4-2.2-1.1-4.1-3.2-5.3   c-0.9-1.8-0.5-3,1.2-3.8c2.6,0.5,4.1,2.3,5.1,4.6c1.4,3.1,1.6,6.4,1.5,9.8c-0.1,2.7-0.4,5.3-1,7.9c-0.3,1,0.1,1.4,1,1.7   c4.2,1.3,8.1,3.1,11.6,5.7c2.3,1.7,3.9,3.8,4.9,6.4c0.7,1.9,0.3,3.8-0.7,5.6c-1.3,2.4-3.3,4.1-5.6,5.6c-3.1,2.1-6.5,3.6-10.1,4.7   c-1,0.3-1.4,0.6-1.1,1.8c1,4.9,1.6,9.9,0.5,14.9c-0.1,0.4-0.2,0.9-0.4,1.3c-1.6,5-5.3,7.2-10.4,6c-5.3-1.2-9.6-4.4-13.6-7.9   c-1-0.9-1.5-1-2.6,0c-2.4,2.2-5,4.3-7.9,5.7c-0.8,0-1.3,0.6-2,0.7c-0.2-0.1-0.4-0.2-0.4-0.4c-0.1-0.3-0.1-0.6,0-0.9   c0.4-0.7,0.1-1.3,0-2c0-0.2,0.1-0.4,0.2-0.6c1.6-1.6,3.9-2.5,5.5-4c0.4-0.3,0.8-0.6,1.2-1c1.4-1.3,1.5-1.4,0.2-2.8   c-1.7-1.8-3.3-3.7-4.8-5.8c-0.6-0.8-1.3-1.2-2.4-1.4c-3.1-0.4-6.3-0.8-9.3-1.7c0,0-1.5,1.9-1.5,1.9c0.4,0.8-0.1,2.3-0.9,2.6   c-0.9,0.3-1.6-0.1-1.9-1.1c0.1-0.3,0.8-0.8-0.2-0.9c-0.2,0-0.1-0.5,0-0.8c0-0.3,0.1-0.6,0.1-0.9   C999-145.8,999.5-146.7,998.6-147.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M998.9-142.6c0,0.7,0.8,0.6,1.1,1.1c0.1,0.2,0.6,0.1,0.6-0.2c-0.1-0.7,0.2-0.7,0.7-1   c0.8-0.4-0.1-0.8-0.3-1.1c0.5-0.5,0.9-1.2,1.5-0.1c0,2.5-0.5,5-0.5,7.6c0,1.8,0.3,3.5,0.8,5.3c0.8,2.7,2.1,3.6,5,3.3   c0.3,0,0.6-0.1,0.9,0c0.6,0.3,0.7,1.1,1.6,1.1c0.1-0.4-0.2-1,0.1-1.5c0.1-0.1,0.2-0.2,0.3-0.3c0.7,0,1.3-0.2,2-0.1   c0.3,0.6,0.7,1.2,0,1.8c-0.3,0.3-0.3,0.6,0,0.9c0.1,0.1,0.2,0.2,0.3,0.3c0.1,0.1,0.1,0.1,0.1,0.2c0,0.1-0.1,0.1-0.1,0.1   c-0.2,0.1-0.4,0.2-0.6,0.4c-0.4,0.2-1.2-0.4-1.3,0.5c-1.8,0.7-3.6,1.1-5.5,0.9c-3.9-0.5-6.4-3.2-7.3-7.9c-0.6-3.1-0.7-6.3-0.2-9.5   C998.3-141.3,998-142.2,998.9-142.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M1006.9-199.9c0,0.3,0.2,0.4,0.4,0.6c0.9,0.5,1.9,0.9,1.8,2.2c0,0.4,0.2,0.5,0.6,0.6   c0.7,0.2,0.6,0.7,0.3,1.1c-1.1,0.5-2.1-0.2-3.1-0.1c-2.1,0.1-3,0.6-3.7,2.5c-0.8,1.9-1,3.9-1,6c0,0.8,0.3,1.7-0.5,2.5   c-1.3,0.1-2,0.7-2.1,2c0,1.1,0.9,1.9,0.8,3.1c-1.2-1-1.8-0.6-1.8,0.7c-1.1-5-1.4-10.1,0.1-15.1   C1000-198.1,1002.8-200.1,1006.9-199.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M1033-192.9c-0.7-1.1-1.4-2.1-2.5-2.9c2.6-1.9,5.4-3.3,8.6-4c1.5-0.3,3.1-0.5,4.7,0.1   c-0.9,1.1-1.8,2.1-0.9,3.7c-0.2,0.2-0.4,0.3-0.7,0.3c-2.6,0-5,0.9-7.2,2.2C1034.3-193.1,1033.8-192.6,1033-192.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M990.3-151.8c0.2,0.4,0.4,0.7,0.3,1.1c-3.2-1.6-6.1-3.5-8.1-6.5c-0.3-0.5-0.7-1-0.8-1.6   c-0.2-0.5-0.1-0.9,0.2-1.3c0.3-0.4,1.1-0.7,1.1-0.4c0.5,1.6,1.5,0.5,2.2,0.5c1.8,1.6,3.5,3.2,5.4,4.8c0,0.4-0.2,0.7-0.7,0.6   c-1,0.6-2.2,0-3.2,0.5c0,0.5,0.4,0.6,0.7,0.7c0.3,0.1,2,0.8,2.2,1C990-152.2,990.2-152.1,990.3-151.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M985.4-159.7c-0.6,0.1-0.8,0.8-1.5,0.6c-0.4-0.1-0.8,0.5-1.1,0c-0.3-0.4,0.5-0.6,0.3-1.1   c-0.9,0.1-1.2,0.7-1.4,1.5c-0.4-0.5-0.5-1-0.5-1.6c0.5-0.7,1.5-0.4,2.2-0.9c0.4-0.3,0.5,0,0.6,0.4c0.1,0.3-0.1,0.8,0.5,0.7   c0.4-0.1,0.4-0.5,0.5-0.9C985.5-160.8,985.6-160.3,985.4-159.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M1012.7-198.4c-0.3,0.3-0.7,0.1-1.1,0.3c-1.5,0.7-2.1,0.3-2.3-1.4C1010.5-199.4,1011.7-199,1012.7-198.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M998.9-142.6c-0.3,0.6-0.6,1.2-0.9,1.8c0.1-1.2,0.1-2.3,0.5-3.4c0.1,0.2-0.2,0.7,0.3,0.6   c0.3-0.1,0.6-0.8,0.9-0.1C1000-143.1,999.6-142.6,998.9-142.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M1011.2-124.2c-0.2-0.3-0.5-0.8,0-1c0.6-0.3,0.9,0.4,1.3,0.5C1012.1-124.4,1011.6-124.3,1011.2-124.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M1013-125.1c0-0.1,0-0.2,0-0.3c0.6-0.4,1.1-1,1.9-0.6C1014.4-125.5,1013.8-125.1,1013-125.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M998.6-147.4c1.1,0.8,0.8,1.6,0.1,2.4C998.6-145.8,999.4-146.7,998.6-147.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M1023.7-147.9c-2.2,0-4.5,0-6.7,0c-0.6,0-0.9-0.2-1.2-0.7c-2.6-3.8-4.9-7.8-6.9-11.9c-0.4-0.9-0.5-1.6,0-2.4   c2-4,4.2-7.8,6.6-11.5c0.5-0.7,0.9-1,1.8-1.1c4.5-0.3,9.1-0.3,13.6,0c0.8,0.1,1.3,0.3,1.7,1c2.5,3.7,4.7,7.5,6.7,11.5   c0.4,0.9,0.5,1.5,0,2.4c-2,4-4.2,7.8-6.6,11.5c-0.5,0.8-1.1,1.2-2,1.2C1028.4-147.8,1026-147.8,1023.7-147.9   C1023.7-147.8,1023.7-147.9,1023.7-147.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M1010.9-128.1c-0.1,0-0.2,0.1-0.3,0.1c-0.4,0.5-0.9,0.8-1.5,0.6c-4.2,0.9-6.1,0-7.1-5.5   c-0.6-3.7-0.2-7.4,0.4-11c0.3-0.7-0.3-1.6,0.6-2.1c3.3,0.8,6.6,1.4,9.9,1.8c0.7,0.1,1.2,0.3,1.7,0.9c1.8,2.6,3.9,5,6,7.3   c0.6,0.6,0.6,1-0.1,1.5c-2.4,2.1-5,4-7.8,5.7C1012.3-128.3,1011.5-128.3,1010.9-128.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M1033-192.9c2-1.1,3.9-2.3,6.2-2.9c1.2-0.3,2.4-0.5,3.6-0.2c1.8,0.6,2.6,2.2,3,3.8c1.3,4.8,0.6,9.5-0.3,14.3   c-0.1,0.6-0.4,0.7-1,0.5c-3.2-0.8-6.4-1.3-9.7-1.7c-0.6-0.1-0.9-0.4-1.2-0.8c-1.9-2.5-3.9-5-6.1-7.3c-0.6-0.6-0.5-0.9,0.1-1.4   C1029.4-190,1031.2-191.4,1033-192.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M1047.6-171.1c0.2-0.9,0.6-1.3,1.7-0.9c3.6,1.3,7.1,2.8,10.2,5.1c0.9,0.7,1.7,1.4,2.4,2.3   c1.6,2,1.6,3.8,0,5.8c-1,1.3-2.3,2.3-3.7,3.2c-2.8,1.9-5.9,3.1-9.1,4.2c-0.9,0.3-1.2,0.1-1.4-0.7c-0.9-3-2-5.9-3.2-8.7   c-0.3-0.7-0.3-1.2,0-1.9c0.4-0.8,0.6-1.7,1-2.6c-0.2-0.9,0.4-1.5,0.8-2.1c0.1-0.1,0.1-0.2,0.1-0.3c0.3-0.6,0-1.4,0.6-1.8l0,0   C1047.3-170,1047.1-170.7,1047.6-171.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M985.4-159.7c-0.2-0.4-0.4-0.9-0.5-1.3c-0.1-1.5,0.5-2.7,1.5-3.7c3.6-3.8,8.3-5.7,13.1-7.3   c0.6-0.2,0.7,0.2,0.8,0.6c1,3.2,2.1,6.3,3.5,9.3c0.2,0.5,0.1,1-0.1,1.5c-1.2,2.9-2.4,5.8-3.2,8.8c-0.2,0.8-0.5,1-1.4,0.7   c-2.4-0.8-4.7-1.9-7.1-2.9c-0.5-0.2-1.1-0.2-1.3-0.8C988.6-156.3,986.7-157.7,985.4-159.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M1036.7-144.6c2.6-0.1,5-0.7,7.5-1.3c0.9-0.2,1.2-0.1,1.4,0.9c0.8,4.1,1.3,8.3,0.6,12.5c0,0.2,0,0.3-0.1,0.5   c-0.9,4.4-3,5.6-7.3,4.3c-4.4-1.4-7.9-4.2-11.3-7.1c-0.5-0.4-0.4-0.7,0-1.1c2.3-2.4,4.4-5,6.3-7.7c0.4-0.6,1-0.5,1.6-0.7   C1035.8-144.8,1036.2-144.8,1036.7-144.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M1001.6-184.6c0.1-1.9-0.1-3.9,0.3-5.8c1-5.4,2.7-6.5,8.1-5c2.6,1,5,2.6,7.3,4.1c0.4,0.2,0.8,0.4,1,0.8   c0.3,0.2,0.6,0.5,0.9,0.7c0.7,0.3,1.3,0.6,1.5,1.3c0.5,0.5,0.3,0.9-0.1,1.4c-2.2,2.3-4.2,4.7-6,7.3c-0.4,0.5-0.8,0.7-1.4,0.8   c-3.1,0.4-6.3,0.8-9.3,1.6c-0.9,0.2-1.1-0.1-1.2-0.8C1002.3-180.4,1001.9-182.5,1001.6-184.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M1028.7-143.7c-1.2,1.9-2.8,3.3-4.1,5c-0.4,0.5-0.7,0.2-1-0.1c-1.4-1.6-2.8-3.1-4.3-4.9   C1022.6-143.7,1025.5-143.7,1028.7-143.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M1010.9-174.8c-1.6,2.9-3.1,5.4-4.7,8.2c-1-2.1-1.6-4.1-2.2-6.1c-0.2-0.7,0.2-0.8,0.7-0.8   C1006.6-174,1008.6-174.4,1010.9-174.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M1041.9-156.8c0.9,2.1,1.5,4.1,2.2,6.1c0.2,0.6,0.1,0.8-0.5,0.9c-2,0.5-4.1,0.9-6.3,1.2   C1038.8-151.4,1040.3-153.9,1041.9-156.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M1043-169.3c-0.3,0.8-0.7,1.6-1.1,2.6c-1.6-2.8-3.1-5.3-4.7-8c2.2,0.2,4.2,0.7,6.2,1.1   c1.2,0.2,0.4,1,0.5,1.5C1043.7-171.1,1043.7-170.1,1043-169.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M1010.9-148.5c-2.3-0.5-4.3-0.9-6.3-1.2c-0.6-0.1-0.8-0.3-0.6-1c0.7-1.9,1.3-3.8,2-6   C1007.7-154,1009.2-151.4,1010.9-148.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M1028.9-179.6c-3.3,0-6.3,0-9.5,0c1.3-1.9,2.8-3.5,4.2-5c0.4-0.5,0.7-0.2,1,0.1   C1025.9-183,1027.3-181.4,1028.9-179.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M1043-169.3c0.3-0.9,0.7-1.9,1-2.8c0,0.6,0.5,0.7,0.8,0.9c-0.2,0.6-1.2,0.2-1,1c0.1,0.8,0.7,0.4,1.2,0.5   c0.4,0.1,0.8,0.5,1.2,0.8l0,0c-0.5,0.4-1,1.8-1.8,0.1C1044.2-169.2,1043.6-169.6,1043-169.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M1002.9-146.1c-0.2,0.7-0.4,1.4-0.6,2.1c-0.5-0.5-0.8,0.5-1.3,0.2c-0.2-0.2-0.3-0.6-0.3-0.6   c1.1-0.2,1.1-1.5,2-1.9C1002.8-146.3,1002.9-146.2,1002.9-146.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M1003.3-153.1c-0.7-0.6-0.7-1.3-0.9-2C1003.7-155.1,1004-154.6,1003.3-153.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M1046.4-167.4c-0.2,0.8-0.4,1.5-0.8,2.1C1044.7-166.4,1045.1-167.1,1046.4-167.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M990.6-155c0.4,0.3,0.9,0.5,1.3,0.8c-0.4,0.1-0.8-0.1-1.1,0.2c-0.2,0.3-0.3,0.9-0.8,0.6   c-0.4-0.3,0.1-0.7,0-1.1C990.2-154.7,990.4-154.9,990.6-155z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M1020.7-188.5c-0.5-0.4-1-0.9-1.5-1.3C1020.5-190.4,1020.6-189.5,1020.7-188.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M1036.7-144.6c-0.4,0.3-0.8,0.2-1.3,0.2c-0.2-0.4-0.2-0.7,0.3-0.8C1036.2-145.4,1036.6-145.3,1036.7-144.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M1064.5-164.1c-0.3-0.6-0.3-1.1,0.2-2C1064.9-165.2,1065-164.7,1064.5-164.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M1047.6-171.1c-0.1,0.6-0.2,1.1-0.5,1.6C1046.5-170.8,1046.5-170.9,1047.6-171.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M1010.9-128.1c0.6-0.3,1.2-0.6,1.8-0.9c0,0.2,0,0.4,0,0.6C1012.2-127.9,1011.5-127.8,1010.9-128.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M1047.1-169.5c-0.1,0.7-0.3,1.3-0.6,1.8c-0.1-0.4,0.1-0.9-0.3-1.3c0,0,0,0,0,0   C1046.3-169.4,1046.6-169.6,1047.1-169.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M1026.2-140c0.8,0.1,1,0.4,1.2,0.9C1026.6-138.9,1026.5-139.4,1026.2-140z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M1046.4-194.5c-0.3,0-0.5-0.1-0.5-0.3c0-0.2,0.1-0.4,0.3-0.4c0.2,0,0.4,0,0.4,0.3   C1046.6-194.8,1046.5-194.7,1046.4-194.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M1018.2-190.5c-0.3-0.3-0.7-0.5-1-0.8C1017.7-191.2,1018.6-191.6,1018.2-190.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M1012.7-125.7c-0.3,0-0.6-0.1-0.6-0.5c0-0.3,0.3-0.3,0.6-0.4C1012.7-126.3,1012.7-126,1012.7-125.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M990.3-151.8c-0.3-0.1-0.5-0.3-0.6-0.6C990.4-152.5,990.5-152.4,990.3-151.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M1000.4-145.6c-0.1,0.2-0.1,0.4-0.2,0.4c-0.2,0.1-0.4-0.1-0.3-0.3c0-0.1,0.1-0.3,0.2-0.3   C1000.2-145.8,1000.3-145.6,1000.4-145.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M1009-127.5c0.5-0.2,1-0.4,1.5-0.6c0,0.2,0,0.5,0,0.7c0,0.5,0.6,1-0.2,1.4   C1010.3-126.7,1008.6-126.2,1009-127.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M999.9-192.7c1.1,0.2,1.2,1.1,1.4,1.8c0.1,0.6-0.2,1.3-0.7,1.8c-0.1,0.1-0.4,0-0.5-0.1   c-0.3-0.3-0.7-2.9-0.4-3.3C999.7-192.6,999.9-192.6,999.9-192.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M1039.1-198.3c0,0.4-0.1,0.8-0.6,0.8c-0.6,0-1.1-0.4-1.1-1c-0.1-0.7,0.6-0.3,0.9-0.4   C1038.7-199.1,1039.1-198.9,1039.1-198.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M1033-194.3c-0.1,0.2-0.1,0.3-0.2,0.4c-0.2,0.1-0.3-0.1-0.3-0.3c0-0.1,0.1-0.3,0.2-0.3   C1032.7-194.6,1032.8-194.4,1033-194.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M1024-169.7c4.5,0,8.1,3.5,8,7.9c-0.1,4.7-3.3,8-7.9,8.1c-4.4,0.1-8-3.5-8.1-7.9   C1016-166.1,1019.5-169.6,1024-169.7z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReact);
export default __webpack_public_path__ + "static/media/react.6cdef88584a988b539052d91d716b3e9.svg";
export { ForwardRef as ReactComponent };